/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';
import Loading from '../../Loading';
import Checkbox from '../../Checkbox';
import NCTable from '../../Table';
import Selectable from '../../Selectable';
import Tabs from '../../Tabs';
import Button from '../../Button';
import Tooltip from '../../Tooltip';
import NCHotKeys from '../../HotKeys';
import Popover from '../../Popover';
import DndColumnConfig from './../components/columnConfig';

import { cloneDeep } from 'lodash';

import {
    executeEnterEvent,
    countTitle,
    perceptionRowIndexWithUp,
    focusToTableHeadCheckBox,
    perceptionRowIndexWithDown,
    perceptionRowIndexDropWithDown,
    perceptionRowIndexDropWithUp,
} from '../utils';
import { TABLE_HEAD_CHECKBOX_CLASS_NAME } from '.././constants';
import {
    findParentTd,
    getSysFieldid,
    getGlobalStorage,
    pageTo,
    getSafeRandom,
    isFunction,
    myBrowser,
} from '@platform/api';

import { formatNumber, formatDatetime } from '../../../api/getDataFormat';

import { throttle, debounce, isArray } from 'lodash';

import { formatHTMLMessage } from 'react-intl-universal';
import { object } from 'prop-types';
import InfoGroupHeader from '../../../components/Form/components/icon/infoGroupHeader';
import FastExtend from '../../../FastExtend';

const Table = NCTable.sort(NCTable);
const tableRowHeight = 24;
const defaultColor = ['#111111', '#555555', '#111', '#555'];

const { TabPane: TabPane } = Tabs;

export default class ReferDropDown extends Component {
    constructor(props) {
        super(props);

        if (props.columnConfig[0] && props.columnConfig[0].code) {
            this.columnConfigCommonOrign = cloneDeep(props.columnConfig);
            this.columnConfigCommonOrign[0].code.forEach((e, i) => {
                if (props.defaultDropColumns) {
                    //根据defaultDropColumns过滤要隐藏的列
                    if (!this.columnConfigCommonOrign[0]['checked']) {
                        this.columnConfigCommonOrign[0]['checked'] = {};
                    }
                    if (props.defaultDropColumns.includes(e)) {
                        this.columnConfigCommonOrign[0]['checked'][e] = true;
                    } else {
                        this.columnConfigCommonOrign[0]['checked'][e] = false;
                    }
                } else {
                    let showcolumnNum = 2;
                    if (!this.columnConfigCommonOrign[0]['checked']) {
                        this.columnConfigCommonOrign[0]['checked'] = {};
                    }
                    if (props.columnConfig[0].name[0] === '所属组织') {
                        showcolumnNum = 3;
                    }
                    if (i > showcolumnNum - 1) {
                        this.columnConfigCommonOrign[0]['checked'][e] = false;
                    } else {
                        this.columnConfigCommonOrign[0]['checked'][e] = true;
                        if (props.columnConfig[0].name[0] === '所属组织') {
                            this.columnConfigCommonOrign[0]['checked'][
                                props.columnConfig[0].code[0]
                            ] = false;
                        }
                    }
                }
            });
        }
        this.state = {
            selectedRowIndex: 0, //选择表格行索引
            activeKey: this.getDropActiveKey() || '1', //页签key
            columnConfigWidth: {}, //列宽
            tableWidth: 0, //下拉面板宽度
            addTipVisible: false, //新增按钮气泡提示显隐控制
            currentButtonIndex: -1, // 当前选择的新增按钮（快捷键）
            columnLastData: {}, //拖拽列之前的列宽
            rowIndex: -1, //树表hover时表格各行的索引
            isAddButtonShow: false,
            clearShadow: false,
            isAdjustCoulmnWidth: false,
            // dragOut: false,
            dragOutKey: '',
            dargOutWidth: 0,
            dargOutColumn: [],
            showTips: false, //搜索超过100条时的提示语
            dargOutLine: false, //列设置拖出边框时隐藏竖线
            showColumnConfigDrop: true, //控制下拉参照的列设置面板的显隐
            columnConfigDrop: (JSON.stringify(this.getCommonColumnConfig()) !==
                '{}' &&
                this.getCommonColumnConfig()) || [
                ...cloneDeep(this.columnConfigCommonOrign),
            ], //下拉参照的列设置
            columnConfigCommonDrop: (JSON.stringify(
                this.getCommonColumnConfig()
            ) !== '{}' &&
                this.getCommonColumnConfig()) || [
                ...cloneDeep(this.columnConfigCommonOrign),
            ], //其它参照类型的列设置
            forceUpdateColumn: false, //强制更新表格数据
            closeColumn: true,
            // showDisabledBg: true,
        };
        this.count = 0;
        this.uuid = Date.now() + getSafeRandom();
        this.abandUpdate = false; //防止每次都更新面板的宽度
    }

    componentWillUnmount() {
        this.referScroll = null;
        this.lifecycleStatus = 'unmount';
        document.removeEventListener('mouseup', this.handleMouseUp);
        this.tableBodyInnerScroll && this.tableBodyInnerScroll.removeEventListener('scroll', this.handleTableScroll);
    }

    componentWillMount() {
        this.lifecycleStatus = 'mount';
    }

    componentDidMount() {
        this.props.onRef && this.props.onRef(this);
        this.props.checkAddButtons && this.props.checkAddButtons();
        let Akey = this.getDropActiveKey();
        if (Akey == 2) {
            this.props.checkUsual(false, true);
        }
        this.columnConfigOrign = cloneDeep(this.props.columnConfig);
        let referdroptable = 'refer-drop-' + this.uuid;
        let element = document.getElementsByClassName(referdroptable)[0];
        let flexRight = element.querySelector('.wui-table-fixed-right');
        // let flexLeft = element.querySelector('.wui-table-fixed-left');
        let tableScroll = element.querySelector('.wui-table-scroll');
        let tableBody = tableScroll.querySelector('.wui-table-body');

        this.scrollTableBody = tableBody;

        let tableBorder = tableBody.querySelector('.table-bordered');
        // let tableHeader = tableScroll.querySelector('.wui-table-header');
        // let tableHeaderLeft = flexLeft.querySelector('.wui-table-header');
        // let tableHeaderRight = flexRight.querySelector('.wui-table-header');
        this.tableBodyInnerScroll =
            flexRight && flexRight.querySelector('.wui-table-body-inner');
            if (myBrowser() == 'Firefox' && this.tableBodyInnerScroll) {
                this.tableBodyInnerScroll.style.paddingRight = '17px'
            }
        // tableBodyInnerScroll &&
        //     tableBodyInnerScroll.addEventListener('scroll', () => {
        //         console.log(tableBodyInnerScroll.scrollTop);
        //         let diff =
        //             tableBorder.offsetHeight - tableBodyInnerScroll.scrollTop;

        //         //注意，这是262就是下拉面板最多展示的行数
        //         if (diff < 262) {
        //             this.setState({ showTips: true });
        //         } else if (diff > 262 && this.state.showTips) {
        //             this.setState({ showTips: false });
        //         }
        //         console.log(diff);
        //     });

        this.tableBodyInnerScroll &&
            this.tableBodyInnerScroll.addEventListener(
                'scroll',
                this.handleTableScroll
            );

        // element.addEventListener(
        //     'scroll',
        //     () => {
        //         let noDataStatus = element.querySelector(
        //             '.wui-table-placeholder'
        //         ); //每次移动滚动条时去取值才会区分 历史记录页签与常用页签
        //         // console.log('滚动事件被触发!');
        //         // console.log(
        //         //     this.dropscrolltable && this.dropscrolltable.scrollLeft
        //         // );
        //         //这里的悬浮列是通过right控制的，若设置left控制，是不是不用一直更新值
        //         //实在不行就搞个假的列设置图标，滑动时放在最后一列头部，正常的right列隐藏
        //         flexRight.style.right = -this.dropscrolltable.scrollLeft + 'px';
        //         tableHeader.style.top = this.dropscrolltable.scrollTop + 'px';
        //         tableHeaderLeft.style.top =
        //             this.dropscrolltable.scrollTop + 'px';
        //         tableHeaderRight.style.top =
        //             this.dropscrolltable.scrollTop + 'px';

        //         // let a = parseInt(noDataStatus.style['margin-left']);
        //         let a = -100 + Number(this.dropscrolltable.scrollLeft);
        //         if (noDataStatus) {
        //             noDataStatus.style['margin-left'] = a + 'px';
        //         }
        //     }

        //     // let noDataStatus = element.querySelector('.wui-table-placeholder'); //每次移动滚动条时去取值才会区分 历史记录页签与常用页签
        //     // // console.log('滚动事件被触发!');
        //     // // console.log(
        //     // //     this.dropscrolltable && this.dropscrolltable.scrollLeft
        //     // // );
        //     // //这里的悬浮列是通过right控制的，若设置left控制，是不是不用一直更新值
        //     // flexRight.style.right = -this.dropscrolltable.scrollLeft + 'px';
        //     // // let a = parseInt(noDataStatus.style['margin-left']);
        //     // let a = -100 + Number(this.dropscrolltable.scrollLeft);
        //     // if (noDataStatus) {
        //     //     noDataStatus.style['margin-left'] = a + 'px';
        //     // }
        // );
        // document.addEventListener('mouseup', (event) => {
        //     let {
        //         columnConfigWidth,
        //         dragOutKey,
        //         dargOutWidth,
        //         // dragOut,
        //         dargOutColumn,
        //     } = this.state;
        //     if (this.dragOut) {
        //         //若拖拽完列之后，若所有列的宽度之和小于下拉面板的极大值，更新下拉面板宽度，即极大值范围内随着列的拖动，下拉面板宽度缩短
        //         this.dragOut = false;
        //         dargOutColumn.forEach(
        //             (e) => (columnConfigWidth[e.key] = e.width)
        //         );
        //         columnConfigWidth[dragOutKey] = dargOutWidth;

        //         //列设置宽度记忆
        //         this.pushToColumnConfigWidth();

        //         //关闭列设置面板
        //         this.showColumnConfigPopDrop();

        //         this.setState({
        //             columnConfigWidth,
        //             isAdjustCoulmnWidth: true,
        //             columnLastData: {},
        //         });
        //     }
        // });

        document.addEventListener('mouseup', this.handleMouseUp);
    }

    //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
    componentWillReceiveProps(nextProps) {}

    //handleScroll--优化性能
    handleScroll = () => {
        let noDataStatus = element.querySelector('.wui-table-placeholder'); //每次移动滚动条时去取值才会区分 历史记录页签与常用页签
        // console.log('滚动事件被触发!');
        // console.log(
        //     this.dropscrolltable && this.dropscrolltable.scrollLeft
        // );
        //这里的悬浮列是通过right控制的，若设置left控制，是不是不用一直更新值
        flexRight.style.right = -this.dropscrolltable.scrollLeft + 'px';
        // let a = parseInt(noDataStatus.style['margin-left']);
        let a = -100 + Number(this.dropscrolltable.scrollLeft);
        if (noDataStatus) {
            noDataStatus.style['margin-left'] = a + 'px';
        }
    };

    //--内存泄漏
    handleMouseUp = () => {
        let {
            columnConfigWidth,
            dragOutKey,
            dargOutWidth,
            // dragOut,
            dargOutColumn,
        } = this.state;
        let { refType, type } = this.props;

        if (this.dragOut) {
            //若拖拽完列之后，若所有列的宽度之和小于下拉面板的极大值，更新下拉面板宽度，即极大值范围内随着列的拖动，下拉面板宽度缩短
            this.dragOut = false;
            dargOutColumn.forEach((e) => (columnConfigWidth[e.key] = e.width));
            columnConfigWidth[dragOutKey] = dargOutWidth;

            //列设置宽度记忆
            this.pushToColumnConfigWidth();

            //关闭列设置面板
            if (type === 'dropDown' && refType === 'grid') {
                this.setState({
                    showColumnConfigDrop: false,
                });
            } else {
                this.showColumnConfigPopDrop();
            }

            this.setState({
                columnConfigWidth,
                isAdjustCoulmnWidth: true,
                columnLastData: {},
            });
        }
    };

    //内存泄露
    handleTableScroll = () => {
        let referdroptable = 'refer-drop-' + this.uuid;
        let element = document.getElementsByClassName(referdroptable)[0];
        let flexRight = element.querySelector('.wui-table-fixed-right');
        // let flexLeft = element.querySelector('.wui-table-fixed-left');
        let tableScroll = element.querySelector('.wui-table-scroll');
        let tableBody = tableScroll.querySelector('.wui-table-body');

        this.scrollTableBody = tableBody;

        let tableBorder = tableBody.querySelector('.table-bordered');
        let tableBodyInnerScroll =
            flexRight && flexRight.querySelector('.wui-table-body-inner');
        console.log(tableBodyInnerScroll.scrollTop);
        let diff = tableBorder.offsetHeight - tableBodyInnerScroll.scrollTop;

        //注意，这是262就是下拉面板最多展示的行数
        if (diff < 262) {
            this.setState({ showTips: true });
        } else if (diff > 262 && this.state.showTips) {
            this.setState({ showTips: false });
        }
        console.log(diff);
    };
    // 检查是否是全选
    isAllChecked = () => {
        let {
            selectedValues,
            tableData,
            searchDataSize,
            title,
            jsonInsideRefer,
        } = this.props;
        if (
            tableData[0].rows.filter((e) => {
                return e._disabled;
            }).length !== 0 &&
            tableData[0].rows.length - 1 === searchDataSize &&
            title === jsonInsideRefer['containers-refer-0034']
        ) {
            tableData[0].rows.pop(); //设置空行
        }
        let data = tableData[0].rows || [];
        return !!(
            selectedValues.size &&
            data.length &&
            data.every((e) => !e._disabled && selectedValues.has(e.refpk))
        );
    };

    // 检查是否 中间态
    isIndeterminated = () => {
        let { selectedValues, tableData } = this.props;

        let data = tableData[0].rows || [];
        return (
            selectedValues.size > 0 &&
            data.length &&
            !this.isAllChecked() &&
            data.find((e) => selectedValues.has(e.refpk))
        );
    };

    // 表格部分的全选
    checkAll = (val) => {
        let {
            tableData,
            selectedValues,
            searchDataSize,
            title,
            jsonInsideRefer,
        } = this.props;
        if (
            tableData[0].rows.filter((e) => {
                return e._disabled;
            }).length !== 0 &&
            tableData[0].rows.length - 1 === searchDataSize &&
            title === jsonInsideRefer['containers-refer-0034']
        ) {
            tableData[0].rows.pop(); //设置空行
        }
        let data = tableData[0].rows || [];

        if (val) {
            data.forEach((e) => {
                selectedValues.set(e.refpk, e);
            });
        } else {
            data.forEach((e) => {
                selectedValues.delete(e.refpk);
            });
        }
        let referVal = this.props.showCodeIfPossible([
            ...selectedValues.values(),
        ]);
        this.handleReferVal(referVal);
        this.handleSelectedValues(selectedValues);
        this.handleShowHistory(true);

        // this.setState({ selectedValues });
    };

    handleSelectedValues = (selectedValues) => {
        this.props.updateSelectedValue(selectedValues);
    };
    handleTableData = (tableData) => {
        this.props.updateTableData(tableData);
    };
    handleReferVal = (referVal) => {
        this.props.updateReferVal(referVal);
    };
    handleDropTabsActiveKey = (activeKey) => {
        this.props.updateDropTabsKey(activeKey);
    };
    handleShowHistory = (flag) => {
        this.props.updateShowHistory(flag);
    };
    handleAddButtonShow = (isAddButtonShow) => {
        this.props.upadteAddButtonShow(isAddButtonShow);
    };
    handleSingleSelect = (item) => {
        this.props.useSingleSelect(item);
    };
    handleMultiSelect = () => {
        this.props.useMultiSelect();
    };

    showColumnConfigPopDrop = () => {
        this.props.updateColumnConfigPop();
    };
    setDataState = (data) => {
        this.setState(data);
    };
    // 右侧表格行点击
    onRowClick = async (record, index, e) => {
        // 为了避免和新开发的行框选点选区域选事件冲突
        if (e.ctrlKey || e.shiftKey || e.metaKey) {
            return;
        }
        let { onSureBtnClick } = this.props;
        // 适配岳鹏，相同参照取值的校验
        if (isFunction(onSureBtnClick) && this.props.isLabelDesign) {
            let closeFlag = await onSureBtnClick([record]);
            if (closeFlag === false) {
                return;
            }
        }

        // e.stopPropagation();

        let { isMultiSelectedEnabled, selectedValues } = this.props;
        if (
            (!isMultiSelectedEnabled &&
                e.target.outerHTML ==
                    '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>') ||
            e.target.outerHTML ==
                '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>'
        ) {
            console.log('点击收藏跳过表格');
            return;
        } else if (
            isMultiSelectedEnabled &&
            (e.target.outerHTML ==
                '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>' ||
                e.target.outerHTML ==
                    '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>')
        ) {
            console.log('点击收藏跳过表格');
            return;
        }
        if (isMultiSelectedEnabled) {
            // 多选--待定，之前这里是多选模式
            // selectedValues = new Map([[record.refpk, record]]);
            selectedValues.set(record.refpk, record);
            let referVal = this.props.showCodeIfPossible([
                ...selectedValues.values(),
            ]);
            // this.handleShowHistory(true); //解决选完一个值之后，历史记录页签切换问题

            // this.handleMultiSelect();
            this.handleReferVal(referVal);
        } else {
            // 单选
            selectedValues = new Map(
                Object.entries({ [record.refpk]: record })
            );
            let referVal = this.props.showCodeIfPossible([
                ...selectedValues.values(),
            ]);
            this.handleShowHistory(true);

            this.handleSingleSelect(record);
            this.handleReferVal(referVal);

            // this.props.handleHideDropTable(); //弹窗，收起下拉面板
            this.props.handleOnlyHideDropTable();
        }
        this.setState({ selectedRowIndex: index });
        this.handleSelectedValues(selectedValues);
    };

    // 表格行双击
    onRowDoubleClick = async (record, index, e) => {
        e.stopPropagation();
        let {
            isMultiSelectedEnabled,
            selectedValues,
            onSureBtnClick,
            isLabelDesign,
        } = this.props;
        // 适配岳鹏，相同参照取值的校验

        if (isFunction(onSureBtnClick) && isLabelDesign) {
            let closeFlag = await onSureBtnClick([record]);
            if (closeFlag === false) {
                return;
            }
        }
        if (isMultiSelectedEnabled) {
            // 多选
            selectedValues.set(record.refpk, record);

            let referVal = this.props.showCodeIfPossible([
                ...selectedValues.values(),
            ]);
            this.handleSelectedValues(selectedValues);
            this.handleMultiSelect();
            this.handleReferVal(referVal);
            // this.props.handleHideDropTable(); //弹窗，收起下拉面板
            this.props.handleOnlyHideDropTable();
        } else {
            // 单选
            // selectedValues = new Map(
            // 	Object.entries({
            // 		[record.refpk]: record
            // 	})
            // );
            selectedValues.clear();

            let referVal = this.props.showCodeIfPossible([record]);
            this.handleSingleSelect(record);
            this.handleReferVal(referVal);
            // this.handleSelectedValues(selectedValues);
            this.props.handleOnlyHideDropTable();
        }
        // this.handlePopoverBlur();
        // this.props.handleHideDropTable(); //弹窗，收起下拉面板
    };

    // 存入下拉面板页签
    pushToDropActiveKey = (activeKey) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            DropActiveKey = JSON.parse(
                getGlobalStorage('localStorage', 'DropActiveKey') || '{}'
            );

        DropActiveKey[configKey] = activeKey;
        this.props.setStorage('DropActiveKey', JSON.stringify(DropActiveKey));
    };

    //从localStorage中取下拉面板页签值
    getDropActiveKey = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;

        let a = getGlobalStorage('localStorage', 'DropActiveKey');
        let b = getGlobalStorage('localStorage', 'DropActiveKey') || '{}';
        let c = JSON.parse(b);
        // console.log(getGlobalStorage('localStorage', 'DropActiveKey'));
        return c[configKey] || '';
        // return (
        //     JSON.parse(
        //         getGlobalStorage('localStorage', 'DropActiveKey') || '{}'
        //     )[configKey] || ''
        // );
    };

    // 存入列宽度设置
    pushToColumnConfigWidth = () => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, width } = this.props,
            { columnConfigWidth: config } = this.state,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfigWidth = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}'
            );

        ColumnConfigWidth[configKey] = config;
        this.props.setStorage(
            'ColumnConfigWidth',
            JSON.stringify(ColumnConfigWidth)
        );
    };

    // render中存入列宽度设置
    pushAdjustColumnConfigWidth = (config) => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, width } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfigWidth = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}'
            );

        ColumnConfigWidth[configKey] = config;
        this.props.setStorage(
            'ColumnConfigWidth',
            JSON.stringify(ColumnConfigWidth)
        );
    };

    // 从localStorage中取下拉面板列宽度设置
    getColumnConfigWidth = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, width } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}'
            )[configKey] || {}
        );
    };

    // 重置下拉面板列宽度设置
    resetColumnConfigWidth = () => {
        //若有滚动条，把滚动条置为0后在localStorage中存值
        if (this.dropscrolltable && this.dropscrolltable.scrollLeft > 0) {
            this.dropscrolltable.scrollLeft = 0;
        }

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, width } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfigWidth = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}'
            );
        delete ColumnConfigWidth[configKey];
        this.props.setStorage(
            'ColumnConfigWidth',
            JSON.stringify(ColumnConfigWidth)
        );
        this.setState({ columnConfigWidth: {} });
    };

    // 重置其他参照下拉面板列宽度设置
    resetCommonColumnConfigWidth = () => {
        //若有滚动条，把滚动条置为0后在localStorage中存值
        if (this.dropscrolltable && this.dropscrolltable.scrollLeft > 0) {
            this.dropscrolltable.scrollLeft = 0;
        }

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl, width } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfigWidth = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}'
            );
        delete ColumnConfigWidth[configKey];
        this.props.setStorage(
            'ColumnConfigWidth',
            JSON.stringify(ColumnConfigWidth)
        );
        this.setState({ columnConfigWidth: {} });
    };

    // 存入列设置
    pushToCommonColumnConfig = () => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            { columnConfigCommonDrop: config } = this.state,
            configKey = queryGridUrl + queryTreeUrl + userId,
            columnConfigCommonDrop = JSON.parse(
                getGlobalStorage('localStorage', 'CommonColumnConfig') || '{}'
            );

        columnConfigCommonDrop[configKey] = config;
        this.props.setStorage(
            'CommonColumnConfig',
            JSON.stringify(columnConfigCommonDrop)
        );
    };

    // 从localStorage中取列设置
    getCommonColumnConfig = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return JSON.parse(
            getGlobalStorage('localStorage', 'CommonColumnConfig') || '{}'
        )[configKey];
    };

    //调整下拉面板各列的宽度
    onDropBorderHandler = (dropWidth, column, columnsConfig) => {
        // let columnConfig = this.state.columnConfig;
        // let { width = {} } = columnConfig[0];
        let { columnConfigWidth, tableWidth } = this.state;
        let { refType, type } = this.props;

        //待添加，当参照只有一列时，拖拽列宽后列宽不能随意设置，最小值应为参照宽度-40

        // width[column.key] = dropWidth;
        // columnConfig[0].width = width;
        // console.log(DropTabsFlag);
        // if (DropTabsFlag) {
        //     this.referInput && this.referInput.focus();
        // }

        // if (this.scrollTableBody && this.scrollTableBody.scrollLeft > 0) {
        //     this.dropscrolltable.scrollLeft -= dropWidth;
        // }

        //自定义设置最后一列的宽度并保存在 columnConfigWidth中，并在getColumns后重新复制
        let noLastWidth = 0;
        // if (columnsConfig.length >= 1) {
        //     columnsConfig
        //         .slice(0, columnsConfig.length - 1)
        //         .forEach((e) => (noLastWidth += e.width));

        //     // if (this.droptable.offsetWidth - noLastWidth > 200) {
        //     //     this.setState({
        //     //         tableWidth: noLastWidth + 200,
        //     //     });
        //     // }
        //     //若拖拽完列之后，若所有列的宽度之和小于下拉面板的极大值，更新下拉面板宽度，即极大值范围内随着列的拖动，下拉面板宽度缩短
        //     if (noLastWidth + 200 < 700) {
        //         this.setState({
        //             tableWidth: noLastWidth + 200 + 10,
        //         });
        //     }

        //     //若拖拽完列之后，若所有列的宽度之和大于下拉面板的极大值，固定极大值，此时出现滚动条
        //     if (
        //         // columnsConfig[columnsConfig.length - 1].width === 200 &&
        //         noLastWidth + 200 > 700 &&
        //         this.droptable.offsetWidth < 700
        //     ) {
        //         this.setState({
        //             tableWidth: 700 + 10,
        //         });
        //     }

        //     // columnsConfig[columnsConfig.length - 1].width =
        //     //     this.droptable.offsetWidth - noLastWidth;
        // }

        //若拖拽完列之后，若所有列的宽度之和小于下拉面板的极大值，更新下拉面板宽度，即极大值范围内随着列的拖动，下拉面板宽度缩短
        columnsConfig.forEach(
            (e) => (columnConfigWidth[e.key] = this.getWidthNumber(e.width))
        );
        if (dropWidth < column.width) {
            let oldDropData = {};
            oldDropData[column.key] = column.width;

            this.setState({ columnLastData: oldDropData });
            this.isChangeColumnData = true;
        } else if (dropWidth > column.width) {
            let oldDropData = {};

            this.setState({ columnLastData: oldDropData });
        }
        columnConfigWidth[column.key] = dropWidth;
        // let newDroptableWidth = 0;
        // columnsConfig.forEach(
        //     (e) => (newDroptableWidth += columnConfigWidth[e.key])
        // );
        // newDroptableWidth += 8; // 加滚动条的宽度

        // //若拖拽完列之后，若所有列的宽度之和大于下拉面板的极大值，固定极大值，此时出现滚动条
        // if (newDroptableWidth > 700) {
        //     newDroptableWidth = 700;
        // }

        //列设置宽度记忆
        this.pushToColumnConfigWidth();

        //关闭列设置面板
        if (type === 'dropDown' && refType === 'grid') {
            this.setState({
                showColumnConfigDrop: false,
            });
        } else {
            this.showColumnConfigPopDrop();
        }

        this.setState({
            columnConfigWidth,
            isAdjustCoulmnWidth: true,
            // tableWidth: newDroptableWidth,
        });

        let timer = setTimeout(() => {
            this.props.referInput && this.props.referInput.focus();
            clearTimeout(timer);
        }, 10);
    };

    // 渲染：下拉表格页签
    renderDropTabs = () => {
        let { activeKey } = this.state;
        const { refType, title, jsonInsideRefer, isShowUsual } = this.props;
        if (
            title === jsonInsideRefer['containers-refer-0034'] &&
            activeKey == '2'
        ) {
            this.setState({
                activeKey: '1',
            });
        }

        return (
            <div
                className="refer-search-left-area"
                key="1"
                style={refType === 'gridTree' ? { marginTop: '2px' } : {}}
            >
                {
                    <div className="refer-left-tab">
                        <Tabs
                            // tabIndex={this.getTabIndex(
                            //     this.hotKeyElement.tabs
                            // )}
                            activeKey={activeKey}
                            onChange={(k) => {
                                // this.sortCol = null;
                                // let tableData = [
                                //     {
                                //         rows: [],
                                //         page: {
                                //             pageIndex: 0,
                                //             pageSize,
                                //             totalPage: 1,
                                //         },
                                //     },
                                // ];
                                if (k == 2) {
                                    this.props.checkUsual(false, true);
                                } else if (
                                    k == 1 &&
                                    (title ===
                                        jsonInsideRefer[
                                            'containers-refer-0035'
                                        ] ||
                                        title === '')
                                ) {
                                    this.props.loadHistoryData();
                                }
                                this.setState({ activeKey: k });
                                // this.handleDropTabsActiveKey(k);
                                this.pushToDropActiveKey(k);
                            }}
                        >
                            {/* 历史记录/搜索结果/已选择 */}
                            <TabPane
                                tab={
                                    title ||
                                    jsonInsideRefer['containers-refer-0035']
                                }
                                key="1"
                            />
                            {/* 常用 */}
                            {refType !== 'tree' &&
                                isShowUsual &&
                                (title ===
                                    jsonInsideRefer['containers-refer-0035'] ||
                                    title === '') && (
                                    <TabPane
                                        tab={
                                            jsonInsideRefer[
                                                'containers-refer-0014'
                                            ]
                                        }
                                        key="2"
                                    />
                                )}
                        </Tabs>
                    </div>
                }
            </div>
        );
    };

    // 下拉面板表格的按键事件
    onTableKeyPress = (up = false) => {
        let { selectedRowIndex } = this.state,
            { isMultiSelectedEnabled, tableData } = this.props,
            len = tableData[0].rows.length - 1;
        // tableBody =
        //     this.droptable &&
        //     this.droptable.querySelector(`.refer-base-table-scroll-body`); //todo:把这个设置为下拉表格的类名

        // tableBody = this.dropscrolltable;
        let referdroptable = 'refer-drop-' + this.uuid;
        let element = document.getElementsByClassName(referdroptable)[0];
        let flexRight = element.querySelector('.wui-table-fixed-right');
        // let flexLeft = element.querySelector('.wui-table-fixed-left');
        // let tableScroll = element.querySelector('.wui-table-scroll');
        // let tableBody = tableScroll.querySelector('.wui-table-body');

        // this.scrollTableBody = tableBody;

        // let tableBorder = tableBody.querySelector('.table-bordered');
        // let tableHeader = tableScroll.querySelector('.wui-table-header');
        // let tableHeaderLeft = flexLeft.querySelector('.wui-table-header');
        // let tableHeaderRight = flexRight.querySelector('.wui-table-header');
        let tableBodyInnerScroll =
            flexRight && flexRight.querySelector('.wui-table-body-inner');

        if (document.activeElement === this.table || true) {
            //或者是把activeElement的值判断为input
            if (up) {
                // up键
                if (selectedRowIndex == 0) {
                    selectedRowIndex = perceptionRowIndexDropWithUp(
                        selectedRowIndex,
                        isMultiSelectedEnabled
                    );

                    // selectedRowIndex === -1 &&
                    //     focusToTableHeadCheckBox(
                    //         this.droptable,
                    //         this.spaceKeyDown
                    //     );
                    // 处理焦点行超出视口时的scrollTop
                    this.scrollTop = selectedRowIndex * tableRowHeight;
                } else {
                    selectedRowIndex--;
                    // 处理焦点行超出视口时的scrollTop
                    if (
                        tableBodyInnerScroll &&
                        selectedRowIndex * tableRowHeight <
                            tableBodyInnerScroll.scrollTop
                    ) {
                        this.scrollTop = selectedRowIndex * tableRowHeight;
                    }
                }
            } else {
                // down键
                if (selectedRowIndex == len) {
                    selectedRowIndex = perceptionRowIndexDropWithDown(
                        selectedRowIndex,
                        isMultiSelectedEnabled,
                        len
                    );

                    // selectedRowIndex === -1 &&
                    //     focusToTableHeadCheckBox(
                    //         this.droptable,
                    //         this.spaceKeyDown
                    //     );
                    // 处理焦点行超出视口时的scrollTop
                    // this.scrollTop = 0;
                } else {
                    selectedRowIndex++;
                    // 处理焦点行超出视口时的scrollTop
                    if (
                        tableBodyInnerScroll &&
                        (selectedRowIndex + 1) * tableRowHeight >
                            tableBodyInnerScroll.clientHeight +
                                tableBodyInnerScroll.scrollTop
                    ) {
                        this.scrollTop =
                            (selectedRowIndex + 1) * tableRowHeight -
                            tableBodyInnerScroll.clientHeight;
                        this.scrollTop =
                            Math.ceil(this.scrollTop / tableRowHeight) *
                            tableRowHeight; //滚动向上取值，解决滚动与下移不一致
                        if (selectedRowIndex === len) {
                            this.scrollTop += 8;
                        }
                    }
                }
            }
            let timer = setTimeout(() => {
                // 直接设不行，好像bee-table里有对scrollTop的操作，把下面的设值冲掉了
                tableBodyInnerScroll &&
                    (tableBodyInnerScroll.scrollTop = this.scrollTop);

                clearTimeout(timer);
            }, 0);
            this.setState({ selectedRowIndex });
        }
    };

    // 表格行的className
    rowClassName = (record, index) => {
        let { selectedRowIndex, rowIndex } = this.state,
            { selectedValues } = this.props,
            className = '';
        if (selectedValues.get(record.refpk)) {
            className = 'refer-selected-row';
        }
        if (selectedRowIndex === index) {
            className += ' refer-key-focus-row';
        }
        if (rowIndex === index) {
            className += ' refer-focus-row';
        }
        if (rowIndex === index && selectedValues.get(record.refpk)) {
            className += ' refer-hover-select-row';
        }
        return className.trim();
    };

    // 根据columnConfig获取下拉参照的基本列信息
    getDropColumns = (selectedShow, DropDownSearchFlag) => {
        const {
            treeConfig,
            refType,
            type,
            columnConfig,
            searchKey,
            jsonInsideRefer,
        } = this.props;
        let { columnConfigDrop } = this.state;

        // let finalColumnConfig = [...columnConfig];

        // if (type === 'dropDown' && refType === 'grid') {
        //     finalColumnConfig = [...this.state.columnConfigDrop];
        // }
        let {
            name: names,
            code: codes,
            checked = {},
            width = {},
            itemtype = {},
            contentcolor = {},
        } = columnConfigDrop[0];
        let searchVal;

        // if (
        //     treeConfig &&
        //     treeConfig.name &&
        //     treeConfig.name[0] === '名称' &&
        //     treeConfig.name.length === 1
        // ) {
        //     treeConfig.name[0] = (jsonInsideRefer || {})[
        //         'containers-refer-0039'
        //     ];
        // }

        //表头添加列设置

        // names.push('columnconfig');
        names = [...new Set(names)];
        codes = [...new Set(codes)];
        if (DropDownSearchFlag) {
            searchVal = searchKey;
        }
        // if (treeConfig.name.length === 2) {
        //     treeConfig.name = [...names];
        //     treeConfig.code = [...codes];
        // }

        return refType === 'tree'
            ? treeConfig.name.map((e, i) => {
                  return {
                      title: (
                          <span
                              className="refer-table-title"
                              fieldid={getSysFieldid(treeConfig.code[i])}
                              title={e}
                          >
                              {e}
                          </span>
                      ),
                      label: e,
                      key: treeConfig.code[i],
                      width: (treeConfig.width && treeConfig.width[treeConfig.code[i]]) || '150px',
                      isSort: true,
                      filterable: true,
                      sorter: function (a, b) {
                          let key = treeConfig.code[i];
                          let aValue =
                              a[key] ||
                              a?.values?.[key]?.value ||
                              a?.values?.[key]?.display ||
                              '';
                          let bValue =
                              b[key] ||
                              b?.values?.[key]?.value ||
                              b?.values?.[key]?.display ||
                              '';
                          return aValue >= bValue ? 1 : -1;
                      },
                      render: (text, row) => {
                          let label =
                              row[treeConfig.code[i]] ||
                              (row.values &&
                                  row.values[codes[i]] &&
                                  (row.values[codes[i]].display ||
                                      row.values[codes[i]].value ||
                                      ''));
                          let highlightLabel =
                              label && searchVal && !selectedShow
                                  ? this.renderTableLabelHighLight(
                                        label,
                                        codes[i],
                                        searchVal,
                                        true
                                    )
                                  : label;
                          return (
                              <div
                                  className="refer-td"
                                  fieldid={getSysFieldid(treeConfig.code[i])}
                                  title={label}
                              >
                                  {highlightLabel || <span>&nbsp;</span>}
                              </div>
                          );
                      },
                  };
              })
            : names
                  .map((e, i) => {
                      return {
                          title: (
                              <span
                                  className="refer-table-title"
                                  fieldid={getSysFieldid(codes[i])}
                                  title={e}
                                  style={{
                                      color: defaultColor.includes(
                                          contentcolor[codes[i]]
                                      )
                                          ? ''
                                          : contentcolor[codes[i]],
                                  }}
                              >
                                  {e}
                              </span>
                          ),
                          label: e,
                          key: codes[i],
                          width: width[codes[i]] || '150px',
                          isSort: true,
                          filterable: true,
                          sorter: function (a, b) {
                              let key = codes[i];
                              let aValue =
                                  a[key] ||
                                  a?.values?.[key]?.value ||
                                  a?.values?.[key]?.display ||
                                  '';
                              let bValue =
                                  b[key] ||
                                  b?.values?.[key]?.value ||
                                  b?.values?.[key]?.display ||
                                  '';
                              return aValue >= bValue ? 1 : -1;
                          },
                          render: (text, row) => {
                              let label =
                                  row[codes[i]] ||
                                  (row.values &&
                                      row.values[codes[i]] &&
                                      (row.values[codes[i]].display ||
                                          row.values[codes[i]].value ||
                                          ''));

                              //在这进行数据的判断、转换
                              //在这解析出itemtype,形如width
                              let itemstyle = itemtype[codes[i]] || '';
                              switch (itemstyle) {
                                  case 'datepicker':
                                      label = formatDatetime(label, 'date');
                                      break;
                                  case 'datetimepicker':
                                      label = formatDatetime(label, 'datetime');
                                      break;
                                  case 'timepicker':
                                      label = formatDatetime(label, 'time');
                                      break;
                                  case 'number':
                                      label = formatNumber(label);
                                      break;
                                  default:
                                      break;
                              }
                              //   label =
                              //       itemstyle === 'datepicker'
                              //           ? formatDatetime(label, 'datetime')
                              //           : itemstyle === 'number'
                              //           ? formatNumber(label)
                              //           : label;

                              let highlightLabel =
                                  label && searchVal && !selectedShow
                                      ? this.renderTableLabelHighLight(
                                            label,
                                            codes[i],
                                            searchVal,
                                            false
                                        )
                                      : label;
                              return (
                                  <div
                                      className="refer-td"
                                      fieldid={getSysFieldid(codes[i])}
                                      title={label}
                                  >
                                      {highlightLabel || <span>&nbsp;</span>}
                                  </div>
                              );
                          },
                          __type__: 'commonColumn',
                      };
                  })
                  .filter((e, i) => checked[codes[i]] !== false);
    };

    // 根据columnConfig获取除下拉参照外的基本列信息
    getDropCommonColumns = (selectedShow, DropDownSearchFlag, isSearchNow) => {
        const {
            treeConfig,
            refType,
            abandGridSort,
            searchKey,
            // selectedValues,
        } = this.props;
        let { columnConfigCommonDrop } = this.state;
        let searchVal;
        // let showSearchFlag;

        //props的columnConfig改成默认编码名称check为true----这个初始值在constructor中调整，后续columnConfig更新在列设置面板进行
        // if (columnConfigCommonDrop[0] && columnConfigCommonDrop[0].checked) {
        //     Object.keys(columnConfigCommonDrop[0].checked).forEach((e, i) => {
        //         if (i > 1) {
        //             columnConfigCommonDrop[0].checked[e] = false;
        //         }
        //     });
        // }

        // let finalColumnConfig = this.getCommonColumnConfig() || [
        //     ...columnConfigCommonDrop,
        // ];

        //若localStorage中有对应的columnConfig值存在，则直接取缓存值，否则使用props，过滤check值
        //local的存储在设置按钮的下拉面板中配置，且注意，若是下拉面板中的列设置，则不应该影响弹窗中的列设置（通过某参数控制）

        let {
            name: names,
            code: codes,
            checked = {},
            width = {},
            itemtype = {},
            contentcolor = {},
        } = columnConfigCommonDrop[0];

        if (!names || names.length === 0) {
            names = [
                '编码',
                // (jsonInsideRefer || {})['containers-refer-0038'],
                '名称',
                // (jsonInsideRefer || {})['containers-refer-0039']
            ];
        }
        if (!codes || codes.length === 0) {
            codes = ['refcode', 'refname'];
        }
        // if (
        //     treeConfig &&
        //     treeConfig.name &&
        //     treeConfig.name[0] === '名称' &&
        //     treeConfig.name.length === 1
        // ) {
        //     treeConfig.name[0] = (jsonInsideRefer || {})[
        //         'containers-refer-0039'
        //     ];
        // }

        //表头添加列设置

        // names.push('columnconfig');
        names = [...new Set(names)];
        codes = [...new Set(codes)];
        if (DropDownSearchFlag) {
            searchVal = searchKey;

            // let splitReferVal = searchVal.split(',');
            // let selectedRefcode = [];

            // for (let val of selectedValues.values()) {
            //     val && selectedRefcode.push(val['refcode']);
            // }

            // isSearchNow = splitReferVal.every((item) => {
            //     return selectedRefcode.includes(item);
            // });
            // isSearchNow = !isSearchNow;
        }
        // if (treeConfig.name.length === 2) {
        //     treeConfig.name = [...names];
        //     treeConfig.code = [...codes];
        // }

        return refType === 'tree'
            ? treeConfig.name.map((e, i) => {
                  return {
                      title: (
                          <span
                              className="refer-table-title"
                              fieldid={getSysFieldid(treeConfig.code[i])}
                              title={e}
                          >
                              {e}
                          </span>
                      ),
                      label: e,
                      key: treeConfig.code[i],
                      width: (treeConfig.width && treeConfig.width[treeConfig.code[i]]) || '150px',
                      isSort: true,
                      filterable: true,
                      sorter: function (a, b) {
                          let key = treeConfig.code[i];
                          let aValue =
                              a[key] ||
                              a?.values?.[key]?.value ||
                              a?.values?.[key]?.display ||
                              '';
                          let bValue =
                              b[key] ||
                              b?.values?.[key]?.value ||
                              b?.values?.[key]?.display ||
                              '';
                          return aValue >= bValue ? 1 : -1;
                      },
                      render: (text, row) => {
                          let label =
                              row[treeConfig.code[i]] ||
                              (row.values &&
                                  row.values[codes[i]] &&
                                  (row.values[codes[i]].display ||
                                      row.values[codes[i]].value ||
                                      ''));
                          let highlightLabel =
                              label &&
                              searchVal &&
                              !selectedShow &&
                              (DropDownSearchFlag ? isSearchNow : true)
                                  ? this.renderTableLabelHighLight(
                                        label,
                                        codes[i],
                                        searchVal,
                                        true
                                    )
                                  : label;
                          return (
                              <div
                                  className="refer-td"
                                  fieldid={getSysFieldid(treeConfig.code[i])}
                                  title={label}
                              >
                                  {highlightLabel || <span>&nbsp;</span>}
                              </div>
                          );
                      },
                  };
              })
            : names
                  .map((e, i) => {
                      return {
                          title: (
                              <span
                                  className="refer-table-title"
                                  fieldid={getSysFieldid(codes[i])}
                                  title={e}
                                  style={{
                                      color: defaultColor.includes(
                                          contentcolor[codes[i]]
                                      )
                                          ? ''
                                          : contentcolor[codes[i]],
                                  }}
                              >
                                  {e}
                              </span>
                          ),
                          label: e,
                          key: codes[i],
                          width: width[codes[i]] || '150px',
                          isSort: abandGridSort ? false : true,
                          filterable: true,
                          sorter: function (a, b) {
                              let key = codes[i];
                              let aValue =
                                  a[key] ||
                                  a?.values?.[key]?.value ||
                                  a?.values?.[key]?.display ||
                                  '';
                              let bValue =
                                  b[key] ||
                                  b?.values?.[key]?.value ||
                                  b?.values?.[key]?.display ||
                                  '';
                              return aValue >= bValue ? 1 : -1;
                          },
                          render: (text, row) => {
                              let label =
                                  row[codes[i]] ||
                                  (row.values &&
                                      row.values[codes[i]] &&
                                      (row.values[codes[i]].display ||
                                          row.values[codes[i]].value ||
                                          ''));

                              //在这进行数据的判断、转换
                              //在这解析出itemtype,形如width
                              let itemstyle = itemtype[codes[i]] || '';
                              switch (itemstyle) {
                                  case 'datepicker':
                                      label = formatDatetime(label, 'date');
                                      break;
                                  case 'datetimepicker':
                                      label = formatDatetime(label, 'datetime');
                                      break;
                                  case 'timepicker':
                                      label = formatDatetime(label, 'time');
                                      break;
                                  case 'number':
                                      label = formatNumber(label);
                                      break;
                                  default:
                                      break;
                              }
                              //   label =
                              //       itemstyle === 'datepicker'
                              //           ? formatDatetime(label, 'datetime')
                              //           : itemstyle === 'number'
                              //           ? formatNumber(label)
                              //           : label;

                              let highlightLabel =
                                  label &&
                                  searchVal &&
                                  !selectedShow &&
                                  (DropDownSearchFlag ? isSearchNow : true)
                                      ? this.renderTableLabelHighLight(
                                            label,
                                            codes[i],
                                            searchVal,
                                            false
                                        )
                                      : label;
                              return (
                                  <div
                                      className="refer-td"
                                      fieldid={getSysFieldid(codes[i])}
                                      title={label}
                                  >
                                      {highlightLabel || <span>&nbsp;</span>}
                                  </div>
                              );
                          },
                          __type__: 'commonColumn',
                      };
                  })
                  .filter((e, i) => checked[codes[i]] !== false);
    };

    // tableData highlight---判断每条渲染的行数据是否包含搜索关键字，若存在高亮显示
    renderTableLabelHighLight = (title, tableKey, searchKey, flag) => {
        let searchKeys = this.getSearchConfigCodes(true);
        let res = title;
        if (flag) {
            res = countTitle(title, searchKey);
        } else {
            if (searchKeys.includes(tableKey)) {
                res = countTitle(title, searchKey);
            } else {
                res = title;
            }
        }

        return res;
    };

    // 获取搜索设置为true的字段
    getSearchConfigCodes = (flag = false) => {
        let columnConfig =
                typeof this.getColumnConfig === 'function'
                    ? this.getColumnConfig()[0]
                    : {},
            search = columnConfig.search || {},
            codes = [
                ...new Set(Object.keys(search).filter((code) => search[code])),
            ];
        flag && codes.push('refname', 'refcode');
        return codes;
    };

    //渲染下拉参照下拉面板的列设置
    renderDropColumnConfig = () => {
        let { showColumnConfigDrop, columnConfigDrop } = this.state;
        // { name: names, code: codes, checked = {} } = columnConfigInDrop[0],
        let { refType, jsonInsideRefer, type } = this.props;

        return (
            <DndColumnConfig
                columnConfig={columnConfigDrop}
                showColumnConfigPop={showColumnConfigDrop}
                refType={refType}
                type={type}
                jsonInsideRefer={jsonInsideRefer}
                pushToColumnConfig={this.pushToCommonColumnConfig}
                resetColumnConfig={this.resetColumnConfig}
                updateColumnConfig={(updateColumnConfig) => {
                    this.setState({ columnConfigDrop: updateColumnConfig });
                }}
                updateColumnConfigPop={(columnConfigPopFlag) => {
                    this.setState({
                        showColumnConfigDrop: columnConfigPopFlag,
                    });
                }}
            ></DndColumnConfig>
        );
    };

    //渲染其它参照下拉面板的列设置
    renderDropCommonColumnConfig = () => {
        let { showColumnConfigDrop, columnConfigCommonDrop, closeColumn } =
            this.state;
        // { name: names, code: codes, checked = {} } = columnConfigInDrop[0],
        let { refType, jsonInsideRefer, type, treeConfig } = this.props;

        //props的columnConfig改成默认编码名称check为true
        // if (columnConfigCommonDrop[0] && columnConfigCommonDrop[0].checked) {
        //     Object.keys(columnConfigCommonDrop[0].checked).forEach((e, i) => {
        //         if (i > 1) {
        //             columnConfigCommonDrop[0].checked[e] = false;
        //         }
        //     });
        // }

        // let finalColumnConfig = this.getCommonColumnConfig() || [
        //     ...columnConfigCommonDrop,
        // ];
        //传进去的columnConfig控制列设置面板的展示效果（这里还是需要结合local缓存）

        return (
            <DndColumnConfig
                columnConfig={columnConfigCommonDrop}
                treeConfig={treeConfig}
                showColumnConfigPop={showColumnConfigDrop}
                refType={refType}
                type={type}
                jsonInsideRefer={jsonInsideRefer}
                pushToColumnConfig={this.pushToCommonColumnConfig}
                resetColumnConfig={this.resetCommonColumnConfig}
                updateColumnConfig={(updateColumnConfig) => {
                    this.setState({
                        columnConfigCommonDrop: updateColumnConfig,
                    });
                }}
                updateColumnConfigPop={(columnConfigPopFlag) => {
                    this.setState({
                        showColumnConfigDrop: columnConfigPopFlag,
                    });
                }}
                isDropColumnConfig={true}
                closeColumnProps={closeColumn}
                onRef={(node) => (this.ChildColumn = node)}
            ></DndColumnConfig>
        );
    };

    // 从localStorage中取列设置
    getColumnConfig = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { columnConfig, queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            )[configKey] || JSON.parse(JSON.stringify(columnConfig))
        );
    };

    // 重置下拉参照弹出表格的列设置
    resetColumnConfig = () => {
        //点击历史记录时，重置下拉表格的列设置面板
        this.resetColumnConfigWidth();
        console.log(this.columnConfigOrign);

        this.setState({
            showColumnConfigDrop: false,
            columnConfigDrop: cloneDeep(this.columnConfigCommonOrign),
            forceUpdateColumn: true,
        });

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfig = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            );
        delete ColumnConfig[configKey];
        this.props.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
        // this.setState({ columnConfigDrop: this.getColumnConfig() });
    };

    // 重置其他参照下拉面板的列设置
    resetCommonColumnConfig = () => {
        //点击历史记录时，重置下拉表格的列设置面板
        this.resetCommonColumnConfigWidth();
        console.log(this.columnConfigCommonOrign);

        this.setState({
            showColumnConfigDrop: false,
            columnConfigCommonDrop: cloneDeep(this.columnConfigCommonOrign),
            forceUpdateColumn: true,
        });

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            CommonColumnConfig = JSON.parse(
                getGlobalStorage('localStorage', 'CommonColumnConfig') || '{}'
            );
        delete CommonColumnConfig[configKey];
        this.props.setStorage(
            'CommonColumnConfig',
            JSON.stringify(CommonColumnConfig)
        );
        // this.setState({ columnConfigDrop: this.getColumnConfig() });
    };

    getWidthNumber = (width) => {
        if(typeof width === 'number'){
            return width;
        }else if(typeof width === 'string'){
            let reg = /\d+/g;
            let res = width.match(reg);
            return res ? Number(res[0]) : 0; 
        }
    }


    render() {
        let {
                tableData,
                jsonInsideRefer,
                fieldValued,
                hasAddButton,
                addButtonList,
                width,
                onFocus,
                type,
                refType,
                attrcode,
                stopPropagationWhenDropdownPressEnter = true, // 表格里不阻止冒泡，因为enter要跳到下一个单元格
                isShowUsual,
                title,
                searchDataSize,
                isMultiSelectedEnabled,
                addButtonDropDown,
                containerDom,
                onEnter,
                showClassification,
                footer,
                rowKey,
                enterKeybord,
                treeConfig,
            } = this.props,
            {
                columnConfigWidth,
                tableWidth,
                currentButtonIndex,
                columnLastData,
                isAddButtonShow,
                clearShadow,
                isAdjustCoulmnWidth,
                showTips,
                dargOutLine,
                forceUpdateColumn,
            } = this.state;

        let columns = [];

        //解决关闭再打开弹窗后，tips还悬浮在底部
        let referdroptable = 'refer-drop-' + this.uuid;
        let element = document.getElementsByClassName(referdroptable)[0];
        if (element) {
            let flexRight = element.querySelector('.wui-table-fixed-right');
            let tableBodyInnerScroll =
                flexRight && flexRight.querySelector('.wui-table-body-inner');
            if (
                showTips &&
                tableBodyInnerScroll &&
                tableBodyInnerScroll.scrollTop === 0
            ) {
                showTips = false;
            }
        }

        //根据参照输入框宽度调整下拉面板最大宽度
        let MAX_DROP_WIDTH = 504;

        if (MAX_DROP_WIDTH < width) {
            MAX_DROP_WIDTH = width;
        }

        //-----------------------
        isShowUsual &&
            refType !== 'tree' &&
            columns.push({
                isSort: false,
                // 序号
                // title: (
                //     <span fieldid={getSysFieldid('numberindex')} title={'收藏'}>
                //         收藏
                //     </span>
                // ), // 序号列
                key: '__index__',
                width:
                    columnConfigWidth['__index__'] ||
                    (this.props.isMultiSelectedEnabled ? 24 : 30),
                fixed: 'left',
                render: (text, row, index) => {
                    return (
                        <span
                            fieldid={getSysFieldid('numberindex')}
                            title={
                                this.props.collectUsualData.size !== 0
                                    ? this.props.collectUsualData.get(
                                          row[fieldValued]
                                      ) ||
                                      this.props.collectUsualData.get(row.refpk)
                                        ? jsonInsideRefer[
                                              'containers-refer-0068'
                                          ]
                                        : jsonInsideRefer[
                                              'containers-refer-0020'
                                          ]
                                    : jsonInsideRefer['containers-refer-0020']
                            }
                        >
                            {/* {index + 1} */}
                            <span
                                className={`iconfont ${
                                    this.props.collectUsualData.size !== 0
                                        ? this.props.collectUsualData.get(
                                              row[fieldValued]
                                          ) ||
                                          this.props.collectUsualData.get(
                                              row.refpk
                                          )
                                            ? 'icon-shoucangdianliang'
                                            : 'icon-shoucang'
                                        : 'icon-shoucang'
                                }`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    console.log(row.refpk, row);
                                    let useStar = true;

                                    if (
                                        this.props.collectUsualData.size !==
                                            0 &&
                                        !!(
                                            this.props.collectUsualData.get(
                                                row[fieldValued]
                                            ) ||
                                            this.props.collectUsualData.get(
                                                row.refpk
                                            )
                                        )
                                    ) {
                                        this.props.usualCollectAction(
                                            'delete',
                                            row.refpk,
                                            index
                                        );
                                    } else if (
                                        this.props.collectUsualData.size ===
                                            0 ||
                                        !(
                                            this.props.collectUsualData.get(
                                                row[fieldValued]
                                            ) ||
                                            this.props.collectUsualData.get(
                                                row.refpk
                                            )
                                        )
                                    ) {
                                        this.props.usualCollectAction(
                                            'save',
                                            '',
                                            0,
                                            useStar,
                                            row
                                        );
                                    }
                                }}
                            ></span>
                        </span>
                    );
                },
            });
        this.props.isMultiSelectedEnabled &&
            columns.unshift({
                isSort: false,
                title: (
                    <label className="refer-table-label">
                        <span
                            className="checkbox-column"
                            fieldid={getSysFieldid('firstcol')}
                        >
                            <Checkbox
                                onChange={this.checkAll}
                                checked={this.isAllChecked()}
                                tabIndex={40}
                                // 增加一个中间态
                                indeterminate={this.isIndeterminated()}
                                className={TABLE_HEAD_CHECKBOX_CLASS_NAME}
                                onKeyDown={this.handleTableHeadCheckboxKeyDown}
                                onKeyUp={this.preventDefaultTableCheckbox}
                            />
                        </span>
                    </label>
                ), // 全选效果
                key: '__checkbox__',
                width: columnConfigWidth['__checkbox__'] || 32,
                fixed: 'left',
                render: (text, row, index) => {
                    return (
                        <label className="refer-table-label">
                            <span
                                fieldid={getSysFieldid('firstcol')}
                                onClickCapture={(e) => {
                                    if (e.ctrlKey || e.shiftKey || e.metaKey) {
                                        e.stopPropagation();
                                    }
                                }}
                            >
                                <Checkbox
                                    onClick={(e) => {
                                        let { selectedValues } = this.props;
                                        e.stopPropagation();
                                        this.props.toggleValueForMapOrObject(
                                            selectedValues,
                                            row.refpk,
                                            row
                                        );
                                        // isMultiSelectMode ||
                                        //     this.onRowClick(row, index, e);
                                        let referVal =
                                            this.props.showCodeIfPossible([
                                                ...selectedValues.values(),
                                            ]);
                                        this.handleReferVal(referVal);
                                        this.handleSelectedValues(
                                            selectedValues
                                        );
                                        // this.handleShowHistory(true);
                                    }}
                                    checked={
                                        this.props.selectedValues.size !== 0
                                            ? !!(
                                                  this.props.selectedValues.get(
                                                      row[fieldValued]
                                                  ) ||
                                                  this.props.selectedValues.get(
                                                      row.refpk
                                                  )
                                              )
                                            : false
                                    }
                                    tabIndex="-1"
                                    disabled={row._disabled}
                                />
                            </span>
                        </label>
                    );
                },
            });

        //若是多选且不是树参照
        // this.props.isMultiSelectedEnabled &&
        //     refType !== 'tree' &&
        //     columns.unshift({
        //         isSort: false,
        //         title: (
        //             <label className="refer-table-label">
        //                 <span
        //                     className="checkbox-column"
        //                     fieldid={getSysFieldid('firstcol')}
        //                 >
        //                     <Checkbox
        //                         onChange={this.checkAll}
        //                         checked={this.isAllChecked()}
        //                         tabIndex={40}
        //                         // 增加一个中间态
        //                         indeterminate={this.isIndeterminated()}
        //                         className={TABLE_HEAD_CHECKBOX_CLASS_NAME}
        //                         onKeyDown={this.handleTableHeadCheckboxKeyDown}
        //                         onKeyUp={this.preventDefaultTableCheckbox}
        //                     />
        //                 </span>
        //             </label>
        //         ), // 全选效果
        //         key: '__checkbox__',
        //         width: columnConfigWidth['__checkbox__'] || 56,
        //         fixed: 'left',
        //         render: (text, row, index) => {
        //             return (
        //                 <label className={`refer-table-label`}>
        //                     <span
        //                         fieldid={getSysFieldid('firstcol')}
        //                         onClickCapture={(e) => {
        //                             if (e.ctrlKey || e.shiftKey || e.metaKey) {
        //                                 e.stopPropagation();
        //                             }
        //                         }}
        //                     >
        //                         <Checkbox
        //                             onClick={(e) => {
        //                                 let { selectedValues } = this.props;
        //                                 e.stopPropagation();
        //                                 this.props.toggleValueForMapOrObject(
        //                                     selectedValues,
        //                                     row.refpk,
        //                                     row
        //                                 );
        //                                 // isMultiSelectMode ||
        //                                 //     this.onRowClick(row, index, e);
        //                                 let referVal =
        //                                     this.props.showCodeIfPossible([
        //                                         ...selectedValues.values(),
        //                                     ]);
        //                                 this.handleReferVal(referVal);
        //                                 this.handleSelectedValues(
        //                                     selectedValues
        //                                 );
        //                                 this.handleShowHistory(true);
        //                             }}
        //                             checked={
        //                                 this.props.selectedValues.size !== 0
        //                                     ? !!(
        //                                           this.props.selectedValues.get(
        //                                               row[fieldValued]
        //                                           ) ||
        //                                           this.props.selectedValues.get(
        //                                               row.refpk
        //                                           )
        //                                       )
        //                                     : false
        //                             }
        //                             tabIndex="-1"
        //                         />

        //                         <span
        //                             className={`iconfont ${
        //                                 this.props.collectUsualData.size !== 0
        //                                     ? !!(
        //                                           this.props.collectUsualData.get(
        //                                               row[fieldValued]
        //                                           ) ||
        //                                           this.props.collectUsualData.get(
        //                                               row.refpk
        //                                           )
        //                                       )
        //                                         ? 'icon-shoucangdianliang'
        //                                         : 'icon-shoucang'
        //                                     : 'icon-shoucang'
        //                             }`}
        //                             style={{
        //                                 cursor: 'pointer',
        //                                 verticalAlign: 'middle',
        //                             }}
        //                             onClick={() => {
        //                                 console.log(row.refpk, row);
        //                                 let useStar = true;

        //                                 if (
        //                                     this.props.collectUsualData.size !==
        //                                         0 &&
        //                                     !!(
        //                                         this.props.collectUsualData.get(
        //                                             row[fieldValued]
        //                                         ) ||
        //                                         this.props.collectUsualData.get(
        //                                             row.refpk
        //                                         )
        //                                     )
        //                                 ) {
        //                                     this.props.usualCollectAction(
        //                                         'delete',
        //                                         row.refpk,
        //                                         index
        //                                     );
        //                                 } else if (
        //                                     this.props.collectUsualData.size ===
        //                                         0 ||
        //                                     !(
        //                                         this.props.collectUsualData.get(
        //                                             row[fieldValued]
        //                                         ) ||
        //                                         this.props.collectUsualData.get(
        //                                             row.refpk
        //                                         )
        //                                     )
        //                                 ) {
        //                                     this.props.usualCollectAction(
        //                                         'save',
        //                                         '',
        //                                         0,
        //                                         useStar,
        //                                         row
        //                                     );
        //                                 }
        //                             }}
        //                         ></span>
        //                     </span>
        //                 </label>
        //             );
        //         },
        //     });
        let othersColumnConfig; //如果是下拉面板中要列设置项，过滤掉除编码、名称之外的
        if (type === 'dropDown' && refType === 'grid') {
            othersColumnConfig = this.getDropColumns(false, true);
        } else {
            if (title === jsonInsideRefer['containers-refer-0034']) {
                //通过刚才创建的方法获取所有的列设置，但此时的列设置中的check值为true的只显示编码、名称（getDropCommonColumns返回的数据已经通过check过滤）
                //othersColumnConfig中的值就是要显示列设置项
                othersColumnConfig = this.getDropCommonColumns(
                    false,
                    true,
                    true
                );
            } else {
                othersColumnConfig = this.getDropCommonColumns(false, true);
            }
        }

        // let othersColumnConfig = this.props.getCommonColumns(false, true);
        columnConfigWidth = this.getColumnConfigWidth();
        this.deleteColumnFlag = false;
        this.addColumnFlag = false;

        if (JSON.stringify(columnConfigWidth) !== '{}') {
            // if (
            //     Object.keys(columnConfigWidth).length - 3 >
            //     othersColumnConfig.length
            // ) {
            //     //在columnConfigWidth找出来othersColumnConfig中没有的值，置为0
            //     for (let e of othersColumnConfig) {
            //         if (!Object.keys(columnConfigWidth).includes(e.key)) {
            //             columnConfigWidth[e.key] = 0;
            //         }
            //     }
            // } else if (
            //     Object.keys(columnConfigWidth).length - 3 <
            //     Object.keys(othersColumnConfig).length
            // ) {
            //     //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
            //     for (let e of othersColumnConfig) {
            //         if (!Object.keys(columnConfigWidth).includes(e.key)) {
            //             columnConfigWidth[e.key] = 80;
            //         }
            //     }
            // }

            //过滤check,删除掉check等于false的列信息
            othersColumnConfig.forEach(
                (e) => (e.width = columnConfigWidth[e.key])
            ); //下拉面板各列的宽度，自己维护

            //在列设置数据添加/删除时，更新各列宽度数据缓存，
            //注意，是计算完下拉面板宽度后去更新所有列宽，以维持当前下拉面板宽度不实时变化
            if (!isAdjustCoulmnWidth) {
                if (
                    Object.keys(columnConfigWidth).length -
                        this.props.funColumnNum() >
                    othersColumnConfig.length
                ) {
                    tableWidth = 0;
                    Object.values(columnConfigWidth).forEach(
                        (e) => (tableWidth += this.getWidthNumber(e))
                    );
                    // tableWidth += 8; //加滚动条的宽度
                    // tableWidth += 40; //加悬浮列的宽度
                    this.pushAdjustColumnConfigWidth(columnConfigWidth);

                    this.deleteColumnFlag = true;
                } else if (
                    Object.keys(columnConfigWidth).length -
                        this.props.funColumnNum() <
                    othersColumnConfig.length
                ) {
                    tableWidth = 0;

                    Object.values(columnConfigWidth).forEach(
                        (e) => (tableWidth += this.getWidthNumber(e))
                    );
                    // tableWidth += 8; //加滚动条的宽度
                    // tableWidth += 40; //加悬浮列的宽度

                    this.pushAdjustColumnConfigWidth(columnConfigWidth);

                    //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
                    for (let e of othersColumnConfig) {
                        if (!Object.keys(columnConfigWidth).includes(e.key)) {
                            e.width = 80;
                        }
                    }

                    this.addColumnFlag = true;
                }
            }

            //处理列调整时最后一列的宽度
            if (
                // this.lastColumnKey &&
                // othersColumnConfig[othersColumnConfig.length - 1].key !==
                //     this.lastColumnKey
                true &&
                othersColumnConfig[othersColumnConfig.length - 1]
            ) {
                // let lastColumnKeyIndex = othersColumnConfig.findIndex(
                //     (e) => e.key === this.lastColumnKey
                // );
                // let beforeWidth = othersColumnConfig[lastColumnKeyIndex].width;

                if (
                    othersColumnConfig[othersColumnConfig.length - 1].key !==
                    this.lastColumnKey
                ) {
                    this.count = 0;
                    //把上一个加过40的列宽恢复
                    if (this.lastColumnKey) {
                        othersColumnConfig.forEach((e) => {
                            if (e.key === this.lastColumnKey) {
                                // e.width -= 40;
                            }
                        });
                    }
                }
                if (this.count === 0) {
                    this.backWidth =
                        othersColumnConfig[othersColumnConfig.length - 1].width;
                }

                // othersColumnConfig[lastColumnKeyIndex].width = backWidth;
                // othersColumnConfig[othersColumnConfig.length - 1].width =
                //     beforeWidth;

                //为避免问题，先来个原有得复制

                if (!this.deleteColumnFlag && !this.addColumnFlag) {
                    tableWidth = 0;
                    othersColumnConfig.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
                    columns.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
                    // tableWidth += 8; //加滚动条的宽度
                    tableWidth += 40; //加悬浮列的宽度
                }

                //504是ue设置的最大宽度，40是列设置的默认宽度，60是除列设置外最后一列的宽度
                //按道理，该判断逻辑只执行一次
                if (
                    tableWidth > MAX_DROP_WIDTH &&
                    othersColumnConfig[othersColumnConfig.length - 1].width ===
                        this.backWidth
                ) {
                    //tableWidth = MAX_DROP_WIDTH;

                    othersColumnConfig[othersColumnConfig.length - 1].width =
                        this.backWidth + 40;
                    this.count += 1;
                } else if (
                    //该逻辑的执行场景为展示面板后调整了列宽度且使总的列宽大于了面板宽度极值
                    //此时，若调整某列宽度，致使总列宽小于下拉面板宽度极值，执行以下逻辑
                    //以下相当于重新设置各列宽度，计算下拉面板宽度
                    othersColumnConfig[othersColumnConfig.length - 1].width ===
                        this.backWidth + 40 &&
                    tableWidth <= MAX_DROP_WIDTH + 40 &&
                    this.count > 0
                ) {
                    othersColumnConfig[othersColumnConfig.length - 1].width =
                        this.backWidth;
                    tableWidth -= 32; //去除滚动条宽度

                    //如果宽度过小，咋办
                    if (tableWidth < MAX_DROP_WIDTH) {
                        tableWidth = 0;
                        othersColumnConfig.forEach(
                            (e) => (tableWidth += this.getWidthNumber(e.width))
                        );
                        columns.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
                        tableWidth += 8; //加滚动条的宽度
                        tableWidth += 40; //加悬浮列的宽度

                        //若缩小时，横向滑动条在下拉面板的最右侧，滚动条距离右侧的距离设置为0，此时方能使滚动条消失
                        // if (
                        //     this.dropscrolltable &&
                        //     this.dropscrolltable.scrollLeft > 0
                        // ) {
                        //     this.dropscrolltable.scrollLeft = 0;
                        // }
                    }
                }

                //若列宽度拖小，每拖小一次，执行一次以下逻辑
                if (
                    JSON.stringify(columnLastData) !== '{}' &&
                    this.isChangeColumnData
                ) {
                    console.log(Object.keys(columnLastData));
                    this.isChangeColumnData = false;
                    let adjustIndex = othersColumnConfig.findIndex(
                        (e) => e.key === Object.keys(columnLastData)[0]
                    );

                    //如果缩小某一列宽之后的下拉面板的宽度仍大于504，使下拉面板宽度等于极大值且横向滚动条左移对应拖拽缩小宽度
                    if (
                        tableWidth > MAX_DROP_WIDTH &&
                        this.backWidth <
                            othersColumnConfig[othersColumnConfig.length - 1]
                                .width <=
                            this.backWidth + 40 &&
                        othersColumnConfig[adjustIndex] &&
                        othersColumnConfig[adjustIndex].width <
                            Object.values(columnLastData)[0]
                    ) {
                        let diff =
                            Object.values(columnLastData)[0] -
                            othersColumnConfig[adjustIndex].width;
                        // othersColumnConfig[othersColumnConfig.length - 1].width -=
                        //     diff;
                        //tableWidth = MAX_DROP_WIDTH;
                        // tableWidth -= diff;
                        // if (
                        //     this.dropscrolltable &&
                        //     this.dropscrolltable.scrollLeft > 0
                        // ) {
                        //     this.dropscrolltable.scrollLeft -= diff;
                        // }
                    }
                }
            } else {
                tableWidth = 0;
                othersColumnConfig.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
                columns.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
                tableWidth += 8; //加滚动条的宽度
                tableWidth += 40; //加悬浮列的宽度

                //504是ue设置的最大宽度，40是列设置的默认宽度，60是除列设置外最后一列的宽度
                if (
                    tableWidth > 504 &&
                    othersColumnConfig[othersColumnConfig.length - 1] &&
                    othersColumnConfig[othersColumnConfig.length - 1].width ===
                        80
                ) {
                    //tableWidth = 504;
                    othersColumnConfig[
                        othersColumnConfig.length - 1
                    ].width = 120;
                } else if (
                    othersColumnConfig[othersColumnConfig.length - 1] &&
                    othersColumnConfig[othersColumnConfig.length - 1].width ===
                        120 &&
                    tableWidth <= 504
                ) {
                    if (othersColumnConfig[othersColumnConfig.length - 1]) {
                        othersColumnConfig[
                            othersColumnConfig.length - 1
                        ].width = 80;
                        tableWidth -= 40;
                    }
                }

                if (
                    JSON.stringify(columnLastData) !== '{}' &&
                    othersColumnConfig[othersColumnConfig.length - 1]
                ) {
                    console.log(Object.keys(columnLastData));
                    let adjustIndex = othersColumnConfig.findIndex(
                        (e) => e.key === Object.keys(columnLastData)[0]
                    );
                    if (
                        tableWidth > 504 &&
                        80 <
                            othersColumnConfig[othersColumnConfig.length - 1]
                                .width <=
                            120 &&
                        othersColumnConfig[adjustIndex].width <
                            Object.values(columnLastData)[0]
                    ) {
                        let diff =
                            Object.values(columnLastData)[0] -
                            othersColumnConfig[adjustIndex].width;
                        // othersColumnConfig[othersColumnConfig.length - 1].width -=
                        //     diff;
                        //tableWidth = 504;
                        // tableWidth -= diff;
                        if (
                            this.dropscrolltable &&
                            this.dropscrolltable.scrollLeft > 0
                        ) {
                            this.dropscrolltable.scrollLeft -= diff;
                            let flexRight = document.querySelector(
                                '.wui-table-fixed-right'
                            );
                            let a = parseInt(flexRight.style.right);
                            a = a + diff;
                            // flexRight.style.right = a + 'px';
                        }
                    }
                }
            }

            if (tableWidth > MAX_DROP_WIDTH) {
                // tableWidth = MAX_DROP_WIDTH;
            }
            tableWidth += 1; //暂无数据的情况下，少1px,有滚动条
        } else {
            tableWidth = 0;
            othersColumnConfig.forEach((e, index) => {
                //不显示所属分类
                // if (showClassification) {
                //     if (index === 0) {
                //         e.width = 100;
                //     } else if (index === 1) {
                //         e.width = 150;
                //     } else {
                //         e.width = 80;
                //     }
                // } else {
                //     if (index === 0) {
                //         e.width = 150;
                //     } else if (index === 1) {
                //         e.width = 100;
                //     } else {
                //         e.width = 80;
                //     }
                // }
                if(!e.width){
                    if (index === 0) {
                        e.width = 150;
                    } else if (index === 1) {
                        e.width = 100;
                    } else {
                        e.width = 80;
                    } 
                }
            }); //下拉面板各列的宽度，设置默认值
            othersColumnConfig.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
            columns.forEach((e) => (tableWidth += this.getWidthNumber(e.width)));
            // tableWidth += 8; //加滚动条的宽度
            tableWidth += 40; //加悬浮列的宽度
            tableWidth += 1; //暂无数据的情况下，少1px,有滚动条

            //表参照与树参照只有两列时，是不是第一次渲染的时候执行就行，若coulmnConfigWidth有值了，按照对应值渲染即可
            //不能仅第一次渲染配置columnConfig,若后期调整分辨率，参照宽度变了，咋办
            if (
                othersColumnConfig.length === 2 &&
                isAdjustCoulmnWidth === false
            ) {
                if (width < 232) {
                    width = 232;
                }
                tableWidth = width;
                let averageWidth;
                if (isMultiSelectedEnabled) {
                    othersColumnConfig.forEach((e, index) => {
                        if (isShowUsual) {
                            averageWidth = (width - 32 - 40 - 24) / 2;
                        } else {
                            averageWidth = (width - 32 - 40) / 2;
                        }
                        e.width = averageWidth;
                        if (index === 0 && width <= 504) {
                            e.width = 150;
                        }
                    }); //下拉面板各列的宽度，设置默认值
                } else {
                    othersColumnConfig.forEach((e, index) => {
                        if (isShowUsual) {
                            averageWidth = (width - 40 - 30) / 2;
                        } else {
                            averageWidth = (width - 40) / 2;
                        }
                        e.width = averageWidth;
                        if (index === 0 && width <= 504) {
                            e.width = 150;
                        }
                    }); //下拉面板各列的宽度，设置默认值
                }
                if (width <= 504) {
                    tableWidth += 150 - averageWidth; //编码字段默认显示150
                }
                tableWidth += 1; //暂无数据的情况下，少1px,有滚动条
            }

            //下拉参照只有一列时，是不是第一次渲染的时候执行就行，若coulmnConfigWidth有值了，按照对应值渲染即可
            if (
                othersColumnConfig.length === 1 &&
                !othersColumnConfig[0].width &&
                isAdjustCoulmnWidth === false
            ) {
                if (width < 232) {
                    width = 232;
                }
                tableWidth = width;
                let averageWidth;
                if (isMultiSelectedEnabled) {
                    othersColumnConfig.forEach((e, index) => {
                        // let averageWidth = width - 32; //下拉参照先不加列设置，故减去40

                        if (isShowUsual) {
                            averageWidth = width - 32 - 24 - 40;
                        } else {
                            averageWidth = width - 32 - 40;
                        }

                        e.width = averageWidth;
                    }); //下拉面板各列的宽度，设置默认值
                } else {
                    othersColumnConfig.forEach((e, index) => {
                        // let averageWidth = width; //下拉参照先不加列设置，故减去40
                        if (isShowUsual) {
                            averageWidth = width - 30;
                        } else {
                            averageWidth = width;
                        }
                        e.width = averageWidth - 40;
                    }); //下拉面板各列的宽度，设置默认值
                }

                if (tableData[0].rows.length > 10) {
                    tableWidth += 8;
                }
                tableWidth += 1; //暂无数据的情况下，少1px,有滚动条
            }
        }

        //表参照与树参照只有两列时，是不是第一次渲染的时候执行就行，若coulmnConfigWidth有值了，按照对应值渲染即可
        //不能仅第一次渲染配置columnConfig,若后期调整分辨率，参照宽度变了，咋办
        if (
            othersColumnConfig.length === 2 &&
            isAdjustCoulmnWidth === false &&
            !this.abandUpdate &&
            JSON.stringify(columnConfigWidth) === '{}'
        ) {
            if (width < 232) {
                width = 232;
            }
            tableWidth = width;
            let averageWidth;
            if (isMultiSelectedEnabled) {
                othersColumnConfig.forEach((e, index) => {
                    if (isShowUsual) {
                        averageWidth = (width - 32 - 40 - 24) / 2;
                    } else {
                        averageWidth = (width - 32 - 40) / 2;
                    }
                    e.width = averageWidth;
                    if (index === 0 && width <= 504) {
                        e.width = 150;
                    }
                }); //下拉面板各列的宽度，设置默认值
            } else {
                othersColumnConfig.forEach((e, index) => {
                    if (isShowUsual) {
                        averageWidth = (width - 40 - 30) / 2;
                    } else {
                        averageWidth = (width - 40) / 2;
                    }
                    e.width = averageWidth;
                    if (index === 0 && width <= 504) {
                        e.width = 150;
                    }
                }); //下拉面板各列的宽度，设置默认值
            }
            if (width <= 504) {
                tableWidth += 150 - averageWidth; //编码字段默认显示150
            }
            tableWidth += 1; //暂无数据的情况下，少1px,有滚动条
            if (
                title === jsonInsideRefer['containers-refer-0036'] ||
                tableData[0].rows.length > 10
            ) {
                tableWidth += 8;
            }
        }

        //下拉参照只有一列时，是不是第一次渲染的时候执行就行，若coulmnConfigWidth有值了，按照对应值渲染即可
        if (
            othersColumnConfig.length === 1 &&
            isAdjustCoulmnWidth === false &&
            !othersColumnConfig[0].width &&
            !this.abandUpdate &&
            JSON.stringify(columnConfigWidth) === '{}'
        ) {
            if (width < 232) {
                width = 232;
            }
            tableWidth = width;
            let averageWidth;
            if (isMultiSelectedEnabled) {
                othersColumnConfig.forEach((e, index) => {
                    // let averageWidth = width - 32; //下拉参照先不加列设置，故减去40
                    if (isShowUsual) {
                        averageWidth = width - 32 - 24 - 40;
                    } else {
                        averageWidth = width - 32 - 40;
                    }
                    e.width = averageWidth;
                }); //下拉面板各列的宽度，设置默认值
            } else {
                othersColumnConfig.forEach((e, index) => {
                    // let averageWidth = width; //下拉参照先不加列设置，故减去40
                    if (isShowUsual) {
                        averageWidth = width - 30;
                    } else {
                        averageWidth = width;
                    }
                    e.width = averageWidth - 40;
                }); //下拉面板各列的宽度，设置默认值
            }
            if (tableData[0].rows.length > 10) {
                tableWidth += 8;
            }
            tableWidth += 1; //暂无数据的情况下，少1px,有滚动条
        }

        // let referdroptable = 'refer-drop-' + attrcode;
        // let element = document.getElementsByClassName(referdroptable)[0];
        // if (tableWidth === 504 && element) {
        //     let flexRight = element.querySelector('.wui-table-fixed-right');
        //     let c = element.querySelector('.wui-table-fixed-left');
        //     let d = element.querySelector('.base-table-bordered');
        //     if (flexRight) {
        //         flexRight.offsetHeight = d.offsetHeight;
        //     }

        //     // if (tableData[0].rows.length) {
        //     //     flexRight.offsetHeight = tableData[0].rows.length * 30;
        //     // }
        //     // if (b % 10 !== 0 && b != 0) {
        //     //     b = b - 8;
        //     //     flexRight.style.height = b + 'px';
        //     // }

        //     console.log(c, d);
        // }

        //取最后一列数据的key，以备置顶、置底调整列设置
        if (othersColumnConfig[othersColumnConfig.length - 1]) {
            this.lastColumnKey =
                othersColumnConfig[othersColumnConfig.length - 1].key;
        }

        columns.push(...othersColumnConfig);

        //表格中添加'设置'按钮this.renderColumnConfig()
        //树参照没有列设置，显示两项的列设置面板可以在列表参照中看
        // refType !== 'tree' &&

        //下拉参照历史记录面板先不展示列设置了
        if (type === 'dropDown' && refType === 'grid') {
            // console.log('sonar 检查');
            columns.push({
                // 操作
                title: (
                    <span
                        fieldid={getSysFieldid('opr')}
                        onClick={() => {
                            this.setState({ isAdjustCoulmnWidth: false });
                            this.abandUpdate = true;
                        }}
                    >
                        {this.renderDropColumnConfig()}
                    </span>
                ), // 全选效果
                key: '__opt__',
                width: columnConfigWidth['__opt__'] || 40,
                fixed: 'right',
                render: (text, row, index) => {
                    return;
                },
            });
            if (isAdjustCoulmnWidth) {
                tableWidth = 0;
                columns.forEach((e) => {
                    tableWidth += this.getWidthNumber(e.width);
                });
                if (tableWidth < width) {
                    tableWidth = width;
                }
            }
        } else {
            columns.push({
                // 操作--需要给renderColumnConfig传的参数是columnConfig（但现在设个是state中的columnconfig）,这里是否可以考虑传进去columnConfig并把修改显示项
                //这个设置按钮的渲染直接不用popRefer中的了，写成类似于下拉参照的形式，columnConfig的状态在该js中维护
                title: (
                    <span
                        fieldid={getSysFieldid('opr')}
                        onClick={() => {
                            this.setState({
                                isAdjustCoulmnWidth: false,
                                // closeColumn: true,
                            });
                            this.abandUpdate = true;
                        }}
                    >
                        {/* {this.props.renderColumnConfig()} */}
                        {this.renderDropCommonColumnConfig()}
                    </span>
                ), // 全选效果
                key: '__opt__',
                width: columnConfigWidth['__opt__'] || 40,
                fixed: 'right',
                render: (text, row, index) => {
                    return;
                },
            });
        }

        let newColumns = [...columns];

        //设置记忆功能，在localStorage中存columnConfigWidth即可

        // columns[columns.length - 1].width = 100;
        //列中添加“设置”按钮

        // columns.push({
        //     isSort: false,
        //     title: (
        //         <label className="refer-table-label">
        //             <span
        //                 className="checkbox-column"
        //                 fieldid={getSysFieldid('firstcol')}
        //             >
        //                 {this.props.renderColumnConfig()}
        //             </span>
        //         </label>
        //     ), // 全选效果
        //     key: '__columnconfig__',
        //     width: columnConfigWidth['__checkbox__'] || '55px',
        //     fixed: 'left',

        // });
        //调整完面板后把列宽数据存储在localStorage中
        if (!this.deleteColumnFlag && !this.addColumnFlag) {
            let newColumnConfigWidth = {};
            newColumns.forEach((e) => (newColumnConfigWidth[e.key] = e.width));
            this.pushAdjustColumnConfigWidth(newColumnConfigWidth);
        }

        // if (refType !== 'gridTree' && othersColumnConfig.length === 2 && this.abandUpdate) {
        //     tableWidth -= 8; //下拉面板去除滚动条的宽度z
        // }
        if (addButtonDropDown.length > 0) {
            addButtonList = [...addButtonDropDown];
        }

        if (
            tableData[0].rows.filter((e) => {
                return e._disabled;
            }).length === 0 &&
            tableData[0].rows.length !== 0 &&
            tableData[0].rows.length === searchDataSize &&
            title === jsonInsideRefer['containers-refer-0034']
        ) {
            tableData[0].rows.push({ _disabled: true }); //设置空行
        }

        return [
            <div
                // className="refer-cascading-list disabled-bg-btn"
                //已选或历史记录隐藏的时候把disabled-bg-btn移除
                className={`refer-cascading-list`}
                style={{ display: 'flex' }}
                onMouseDown={(e) => {
                    e.preventDefault();
                }}
            >
                <div>{this.renderDropTabs()}</div>
                {/* <div>{this.props.renderColumnConfig()}</div> */}
                <div
                    className={`refer-table refer-drop-${this.uuid} ${
                        tableData[0].rows &&
                        tableData[0].rows.length === 0 &&
                        'no-data-line'
                    }`}
                    style={{
                        maxWidth:
                            treeConfig?.width ? undefined : (
                                // tableWidth > MAX_DROP_WIDTH + 1
                                //     ? MAX_DROP_WIDTH + 1 + 'px'
                                //     : tableWidth != 0 &&
                                //     (tableWidth < width
                                //         ? width + 'px'
                                //         : tableWidth + 'px')
                                //改成表格宽度之和
                                tableWidth
                            ),
                        maxHeight:
                            title === jsonInsideRefer['containers-refer-0034']
                                ? '291px'
                                : '286px',
                    }}
                    ref={(dom) => {
                        this.dropscrolltable = ReactDOM.findDOMNode(dom);
                    }}
                >
                    <Table
                        height={tableRowHeight}
                        headerHeight={tableRowHeight}
                        onRowClick={this.onRowClick}
                        onRowDoubleClick={this.onRowDoubleClick}
                        // rowKey={'total-row'} //不是这个不更新columns,即bodyColumn
                        rowKey={(record) =>
                            this.props.getDisplayOrValue(record, rowKey)
                        }
                        forceUpdateColumn={forceUpdateColumn}
                        columns={[...newColumns]}
                        data={tableData[0].rows}
                        lazyload={false}
                        scroll={{
                            // 补正1px 避免表格横向滚动条被遮住1px
                            y: this.referTable?.clientHeight - 30 - 1,
                            x: true,
                        }}
                        rowClassName={this.rowClassName}
                        // 补正1px 避免表格横向滚动条被遮住1px
                        // bodyStyle={{
                        //     height: this.referTable?.clientHeight - 30 - 1,
                        // }}
                        focusable
                        // tabIndex={this.getTabIndex(
                        //     this.hotKeyElement.referTable
                        // )}
                        // onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.referTable)}
                        className={`refer-base-table dropdown-table ${'right-table-boxshadow'} ${
                            tableWidth >= MAX_DROP_WIDTH && 'last-sort'
                        } ${
                            tableData[0].rows.length - 1 === searchDataSize &&
                            title ===
                                jsonInsideRefer['containers-refer-0034'] &&
                            'hidden-last-row'
                        } ${
                            tableData[0].rows &&
                            tableData[0].rows.length === 0 &&
                            'no-data-style'
                        } ${dargOutLine && 'drag-resizer-line'}`}
                        bodyClassName="refer-base-table-scroll-body"
                        ref={(dom) => {
                            this.droptable =
                                ReactDOM.findDOMNode(dom)?.querySelector(
                                    `.dropdown-table`
                                );
                        }}
                        // scrollTop={scrollTop}
                        addBlankCol={false}
                        // customSort={sort}
                        // {...emptyText}
                        emptyClassName="refer-select-empty"
                        columnWidthConfig={false}
                        sort={{ sortFun: this.handleSort }}
                        onDropBorderHandler={(dropWidth, column) => {
                            this.onDropBorderHandler(
                                dropWidth,
                                column,
                                newColumns
                            );
                        }}
                        onDragOver={(e) => {
                            console.log(e);
                        }}
                        onDraggingBorder={(e, width, column, columns) => {
                            //e, width, column, columns--通过column获取拖拽项的索引，再通过columns计算拖拽项及之前的宽度
                            //若拖拽宽度大于当前下拉面板的宽度，让其等于拖拽的最大值
                            console.log(this.props.containerDom);
                            if (
                                column &&
                                (column.key === '__index__' ||
                                    column.key === '__checkbox__')
                            ) {
                                return;
                            }
                            let leaveLeftWidth = 0;
                            columns.forEach((e) => {
                                if (e.dragIndex < column['dragIndex']) {
                                    leaveLeftWidth += e.width;
                                }
                            });
                            if (
                                this.scrollTableBody &&
                                this.scrollTableBody.scrollLeft > 0
                            ) {
                                leaveLeftWidth -=
                                    this.scrollTableBody.scrollLeft;
                            }

                            if (leaveLeftWidth + width > tableWidth - 8) {
                                //设置拖拽列的宽度
                                // let columnConfig = this.state.columnConfig;
                                // let { width = {} } = columnConfig[0];
                                // let { columnConfigWidth } = this.state;

                                // //若拖拽完列之后，若所有列的宽度之和小于下拉面板的极大值，更新下拉面板宽度，即极大值范围内随着列的拖动，下拉面板宽度缩短
                                // columns.forEach(
                                //     (e) => (columnConfigWidth[e.key] = e.width)
                                // );
                                // if (width < column.width) {
                                // } else if (width > column.width) {
                                //     let oldDropData = {};

                                //     this.setState({
                                //         columnLastData: oldDropData,
                                //     });
                                // }
                                // columnConfigWidth[column.key] =
                                //     tableWidth - leaveLeftWidth;

                                // //列设置宽度记忆
                                // this.pushToColumnConfigWidth();

                                // //关闭列设置面板
                                // this.showColumnConfigPopDrop();

                                // this.setState({
                                //     columnConfigWidth,
                                //     isAdjustCoulmnWidth: true,
                                //     // tableWidth: newDroptableWidth,
                                // });
                                this.dragOut = true;
                                if (!dargOutLine) {
                                    this.setState({
                                        dargOutLine: true,
                                    });
                                }

                                this.setState({
                                    dragOutKey: column.key,
                                    dargOutWidth: tableWidth - leaveLeftWidth,
                                    // dragOut: true,
                                    dargOutColumn: columns,
                                });

                                let timer = setTimeout(() => {
                                    this.props.referInput &&
                                        this.props.referInput.focus();
                                    clearTimeout(timer);
                                }, 10);
                            } else {
                                // this.setState({
                                //     dragOut: false,
                                // });
                                this.dragOut = false;
                                if (dargOutLine) {
                                    this.setState({
                                        dargOutLine: false,
                                    });
                                }
                            }

                            // let timer = setTimeout(() => {
                            //     this.props.referInput &&
                            //         this.props.referInput.focus();
                            //     clearTimeout(timer);
                            // }, 10);
                        }}
                        onDropBorder={() => {
                            console.log('列宽调整完了');
                        }}
                        onRowHover={(index) => {
                            // if (this.state.selectedRowIndex === 0) {
                            //     this.setState({ selectedRowIndex: -1 });
                            // }
                            this.setState({
                                rowIndex: index,
                                // selectedRowIndex: index,
                            });
                        }}
                    ></Table>
                    {/* {tableData[0].rows.length === searchDataSize &&
                        title === jsonInsideRefer['containers-refer-0034'] && (
                            <div>
                                <span className="drop-tip">
                                    更多搜索结果，请打开弹窗查看
                                </span>
                            </div>
                        )} */}
                    {showTips &&
                        tableData[0].rows.length - 1 === searchDataSize &&
                        title === jsonInsideRefer['containers-refer-0034'] && (
                        <div style={{ height: 0 }}>
                            <span
                                className={`drop-tip ${
                                    showTips &&
                                        tableData[0].rows.length - 1 ===
                                            searchDataSize &&
                                        title ===
                                            jsonInsideRefer[
                                                'containers-refer-0034'
                                            ] &&
                                        'table-footer-drop'
                                }`}
                            >
                                {jsonInsideRefer['containers-refer-0069']}
                            </span>
                        </div>
                    )}
                </div>

                <div
                    className={`drop-table-footer ${
                        tableData[0].rows &&
                        tableData[0].rows.length >= 10 &&
                        'footer-lineheight'
                    }`}
                >
                    {title === jsonInsideRefer['containers-refer-0036'] &&
                        (typeof footer === 'function' ? footer() : footer)}
                    {type !== 'dropDown' && (
                        <span
                            onClick={(event) => {
                                this.props.handleOnlyHideDropTable(); //弹窗，收起下拉面板
                                this.props.handleLoadUsual();

                                if (type === 'dropDown' && refType === 'grid') {
                                    // console.log('sonar 检查');
                                } else {
                                    // this.handleDropTabsActiveKey(
                                    //     this.state.activeKey
                                    // );
                                    // console.log('sonar 检查');
                                }

                                let timer = setTimeout(() => {
                                    this.handleTableData([
                                        {
                                            rows: [],
                                            page: tableData[0].page || {
                                                pageIndex: 0,
                                                totalPage: 1,
                                            },
                                        },
                                    ]);
                                    this.props.beforeEvent(
                                        onFocus,
                                        this.props.show,
                                        event,
                                        { fromIconRefer: true }
                                    );
                                    if (
                                        this.dropscrolltable &&
                                        this.dropscrolltable.scrollLeft > 0
                                    ) {
                                        this.dropscrolltable.scrollLeft = 0;
                                    }
                                    clearTimeout(timer);
                                }, 302);
                                console.log('打开参照弹窗');
                            }}
                            className="openshow"
                        >
                            {/* 新增 */}
                            <span
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {
                                    <span>
                                        {
                                            jsonInsideRefer[
                                                'containers-refer-0065'
                                            ]
                                        }
                                    </span>
                                }
                            </span>
                        </span>
                    )}
                    {(() => {
                        if (hasAddButton && Array.isArray(addButtonList)) {
                            switch (addButtonList.length) {
                                case 0:
                                    return null;
                                case 1:
                                    return (
                                        <span
                                            onClick={() => {
                                                let {
                                                    appcode,
                                                    pagecode,
                                                    urlParam,
                                                } = addButtonList[0];
                                                pageTo.openTo(null, {
                                                    appcode,
                                                    pagecode,
                                                    status: 'browse',
                                                    ...(typeof urlParam ===
                                                        'function' &&
                                                        urlParam()),
                                                });
                                                this.props.handleHideDropTable(); //收起下拉面板
                                                // this.setState({
                                                //     isShow: false,
                                                //     selectedShow: false,
                                                // });
                                            }}
                                            className="add-button"
                                        >
                                            {/* 新增 */}
                                            {
                                                jsonInsideRefer[
                                                    'containers-refer-0046'
                                                ]
                                            }
                                        </span>
                                    );
                                default:
                                    let length = addButtonList.length;
                                    return (
                                        <Popover
                                            className="popover-in-refer add drop-add"
                                            trigger="click"
                                            placement="bottom"
                                            content={
                                                <div className="add-button-wrapper">
                                                    {addButtonList.map(
                                                        (
                                                            {
                                                                name,
                                                                appcode,
                                                                pagecode,
                                                                urlParam,
                                                            },
                                                            i
                                                        ) => {
                                                            return (
                                                                <div
                                                                    className={`add-button-item ${
                                                                        currentButtonIndex >
                                                                            -1 &&
                                                                        ((currentButtonIndex %
                                                                            length) +
                                                                            length) %
                                                                            length ===
                                                                            i
                                                                            ? 'selected'
                                                                            : ''
                                                                    }`}
                                                                    key={name}
                                                                    onClick={() => {
                                                                        pageTo.openTo(
                                                                            null,
                                                                            {
                                                                                appcode,
                                                                                pagecode,
                                                                                status: 'browse',
                                                                                ...(typeof urlParam ===
                                                                                    'function' &&
                                                                                    urlParam()),
                                                                            }
                                                                        );
                                                                        // this.handleAddButtonShow(
                                                                        //     false
                                                                        // ); //收起新增按钮列表
                                                                        this.setState(
                                                                            {
                                                                                isAddButtonShow: false,
                                                                            }
                                                                        );
                                                                        this.props.handleHideDropTable(); //收起下拉面板
                                                                        // this.setState(
                                                                        //     {
                                                                        //         isShow: false,
                                                                        //         selectedShow: false,
                                                                        //     }
                                                                        // );
                                                                    }}
                                                                >
                                                                    {name}
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            }
                                            fieldid="more_btn_menu"
                                            show={isAddButtonShow}
                                            onHide={() => {
                                                // this.handleAddButtonShow(false);
                                                if (!this.addButtonShowFlag) {
                                                    this.setState({
                                                        isAddButtonShow: false,
                                                    });
                                                }
                                                this.addButtonShowFlag = false;
                                            }}
                                            // onVisibleChange={(
                                            //     isAddButtonShow
                                            // ) => {
                                            //     // this.setState({
                                            //     //     isAddButtonShow,
                                            //     // });
                                            //     this.handleAddButtonShow(
                                            //         isAddButtonShow
                                            //     );
                                            // }}
                                            // onVisibleChange={(
                                            //     isAddButtonShow
                                            // ) => {
                                            //     this.setState({
                                            //         isAddButtonShow,
                                            //     });
                                            //     // this.handleAddButtonShow(
                                            //     //     isAddButtonShow
                                            //     // );
                                            // }}
                                        >
                                            <span
                                                onClick={() => {
                                                    this.setState(
                                                        ({
                                                            isAddButtonShow,
                                                        }) => ({
                                                            isAddButtonShow:
                                                                !isAddButtonShow,
                                                            // addTipVisible:
                                                            //     !!isAddButtonShow,
                                                        })
                                                    );
                                                    // this.handleAddButtonShow(
                                                    //     !this.props
                                                    //         .isAddButtonShow
                                                    // );
                                                    // this.setState(
                                                    //     {
                                                    //         addTipVisible:
                                                    //             !!isAddButtonShow,
                                                    //     },
                                                    //     () =>
                                                    //         this.handleAddButtonShow(
                                                    //             !isAddButtonShow
                                                    //         )
                                                    // );
                                                }}
                                                className="add-button"
                                            >
                                                {/* 新增 */}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {
                                                        <span>
                                                            {
                                                                jsonInsideRefer[
                                                                    'containers-refer-0046'
                                                                ]
                                                            }
                                                        </span>
                                                    }
                                                    <i
                                                        className="iconfont icon-hangcaozuoxiala1"
                                                        style={{
                                                            lineHeight: '24px',
                                                            height: '22px',
                                                        }}
                                                    ></i>
                                                </span>
                                            </span>
                                        </Popover>
                                    );
                            }
                        }
                    })()}
                </div>
                {/* 滚动条导致右侧悬浮图标不稳定悬浮居右的另一种解决方式，若滚动条开始被拖拽，隐藏整个fixed-right,显示下面图标
                <span className="drop-fix-icon iconfont icon-lbsz"></span> */}
            </div>,
            <HotKeys
                keyMap={{
                    // add: 'ctrl+/',
                    enter: 'enter',
                    up: 'up',
                    down: 'down',
                    // save:'ctrl+s'
                }}
                handlers={{
                    // add: () => {
                    //     let { addButtonList } = this.props;
                    //     if (
                    //         document.activeElement.className !==
                    //         'wui-input md base-input  refer-input'
                    //     ) {
                    //         return;
                    //     }

                    //     if (Array.isArray(addButtonList)) {
                    //         if (addButtonList.length === 1) {
                    //             // 直接新增
                    //             let { appcode, pagecode, urlParam } =
                    //                 addButtonList[0];
                    //             pageTo.openTo(null, {
                    //                 appcode,
                    //                 pagecode,
                    //                 status: 'browse',
                    //                 ...(typeof urlParam === 'function' &&
                    //                     urlParam()),
                    //             });
                    //         } else if (addButtonList.length > 1) {
                    //             // 展开下拉

                    //             // this.handleAddButtonShow(!isAddButtonShow);
                    //             // this.handleAddButtonShow(true);
                    //             this.setState({
                    //                 isAddButtonShow: !isAddButtonShow,
                    //             });
                    //             this.addButtonShowFlag = true;

                    //             // this.setState(({ isAddButtonShow }) => {
                    //             //     isAddButtonShow = !isAddButtonShow;
                    //             //     if (isAddButtonShow) {
                    //             //         this.preActiveElement =
                    //             //             document.activeElement;
                    //             //         document.activeElement &&
                    //             //             document.activeElement.blur();
                    //             //     } else {
                    //             //         this.preActiveElement &&
                    //             //             this.preActiveElement.focus();
                    //             //         this.preActiveElement = null;
                    //             //     }
                    //             //     return { isAddButtonShow };
                    //             // });
                    //         }
                    //     }
                    // },
                    up: (event) => {
                        let { addButtonList } = this.props;
                        let { isAddButtonShow } = this.state;
                        if (isAddButtonShow) {
                            let length = addButtonList.length;
                            this.setState(({ currentButtonIndex }) => ({
                                currentButtonIndex:
                                    ((--currentButtonIndex % length) + length) %
                                    length,
                            }));
                        } else {
                            this.onTableKeyPress(true);
                            if (this.props.showDropDownTable) {
                                event.stopPropagation();
                            }
                            // if (document.activeElement === this.moreButton) {
                            //     this.setState({
                            //         isMoreButtonShow: false,
                            //     });
                            // }
                        }
                    },
                    down: (event) => {
                        let { addButtonList } = this.props;
                        let { isAddButtonShow } = this.state;

                        if (isAddButtonShow) {
                            let length = addButtonList.length;
                            this.setState(({ currentButtonIndex }) => ({
                                currentButtonIndex:
                                    ((++currentButtonIndex % length) + length) %
                                    length,
                            }));
                        } else {
                            this.onTableKeyPress(false);
                            if (this.props.showDropDownTable) {
                                event.stopPropagation();
                            }
                            // if (document.activeElement === this.moreButton) {
                            //     if (isMoreButtonShow === true) {
                            //         if (this.moreButtonMenu) {
                            //             this.moreButtonMenu?.focus();
                            //         }
                            //     } else {
                            //         this.setState(
                            //             { isMoreButtonShow: true },
                            //             () => {
                            //                 let intervalId = null;
                            //                 intervalId = setInterval(() => {
                            //                     if (this.moreButtonMenu) {
                            //                         this.moreButtonMenu?.focus();
                            //                         clearInterval(intervalId);
                            //                     }
                            //                 }, 50);
                            //             }
                            //         );
                            //     }
                            // }
                        }
                    },
                    enter: (event) => {
                        if (this.props.showDropDownTable) {
                            let { addButtonList, selectedValues } = this.props;
                            let { currentButtonIndex, isAddButtonShow } =
                                this.state;
                            if (isAddButtonShow && currentButtonIndex > -1) {
                                if (this.props.isMultiSelectedEnabled) {
                                    event.stopPropagation();
                                }
                                stopPropagationWhenDropdownPressEnter &&
                                    event.stopPropagation();
                                let { appcode, pagecode, urlParam } =
                                    addButtonList[currentButtonIndex];
                                pageTo.openTo(null, {
                                    appcode,
                                    pagecode,
                                    status: 'browse',
                                    ...(typeof urlParam === 'function' &&
                                        urlParam()),
                                });
                                this.setState({ isAddButtonShow: false });
                                // this.handleAddButtonShow(false);
                            } else {
                                // if (
                                //     this.moreButtonMenu &&
                                //     this.moreButtonMenu.contains(
                                //         document.activeElement
                                //     )
                                // ) {
                                //     return;
                                // }

                                //由于延时componentWillUnmount先执行,导致this.referInput是 null，因此先保存一下单元格
                                // let td =
                                //     this.props.renderInTable &&
                                //     this.referInput &&
                                //     findParentTd(this.referInput);

                                // if (this.props.isMultiSelectedEnabled) {
                                //     event.stopPropagation();
                                // }
                                stopPropagationWhenDropdownPressEnter &&
                                    event.stopPropagation();

                                if (
                                    this.droptable
                                    // this.table.contains(document.activeElement)
                                ) {
                                    // record && this.props.onHotKeyClose();

                                    let { refType, tableData } = this.props,
                                        { selectedRowIndex } = this.state,
                                        record =
                                            tableData[0].rows[selectedRowIndex];
                                    if (
                                        title ===
                                            jsonInsideRefer[
                                                'containers-refer-0036'
                                            ] &&
                                        this.props.showDropDownTable
                                    ) {
                                        this.handleSingleSelect(record);
                                    } else {
                                        // 默认情况下 焦点在表头  record 可能是没有值的 然后就会报错c
                                        if (enterKeybord) {
                                            !record &&
                                                console.log(
                                                    '焦点在表头或者没有获取到选中记录！'
                                                );
                                            record &&
                                                this.onRowClick(
                                                    record,
                                                    selectedRowIndex,
                                                    event
                                                );
                                        }
                                    }
                                }
                                // this.setState({
                                //     closeColumn: false,
                                // });
                                // if (
                                //     this.ChildColumn &&
                                //     this.ChildColumn.shezhi &&
                                //     document.body.contains(
                                //         document.querySelector(
                                //             '.coulmn-popover'
                                //         )
                                //     )
                                // ) {
                                //     this.ChildColumn.shezhi.click();
                                // }
                                this.props.handleOnlyHideDropTable();
                                // this.props.handleHideDropTable(); //收起下拉面板

                                // onEnter 逻辑添加 by bbqin
                                // setTimeout(() => {
                                //     let target = td || this.referInput;
                                //     // 加一个isShow判断逻辑 弹窗关闭之后才可以跳转
                                //     let isShow = this.state.isShow;
                                //     let lifecycleStatus = this.lifecycleStatus;

                                //     // 用于解决参照如果enter后出现闪烁的问题
                                //     const disableEnter =
                                //         document.querySelector(
                                //             '.enter-is-disabled'
                                //         );

                                //     if (
                                //         executePopOverEnterSelect({
                                //             isShow,
                                //             lifecycleStatus,
                                //         }) &&
                                //         !disableEnter
                                //     ) {
                                //         this.props.onEnter &&
                                //             this.props.onEnter({
                                //                 e: event,
                                //                 target,
                                //                 eventKey: 'Enter',
                                //             });
                                //     }
                                //     // 改成40  保证关闭之后执行
                                // }, 40);
                            }

                            //延时导致event.target已被移出dom树因此在此先找一下父元素td，并保存一下
                            let td =
                                this.props.renderInTable &&
                                findParentTd(event.target);
                            //阻止冒泡会影响Page/index 下的keydown 事件
                            //event.stopPropagation();

                            if (
                                !(
                                    isMultiSelectedEnabled &&
                                    status.isSearchStatus
                                ) ||
                                (onEnter && status.isSearchStatus)
                            ) {
                                // 非多选的搜索状态--这里之前setState的是-1

                                // onEnter 逻辑添加 by bbqin
                                let timer = setTimeout(() => {
                                    let currentTarget = td || event.target;
                                    if (
                                        executeEnterEvent({
                                            containerDom,
                                            onEnter,
                                            currentTarget,
                                        })
                                    ) {
                                        onEnter({
                                            e: event,
                                            eventKey: 'Enter',
                                            target: currentTarget,
                                        });
                                    }
                                    clearTimeout(timer);
                                }, 20);

                                if (
                                    this.lifecycleStatus === 'unmount' &&
                                    onEnter
                                ) {
                                    onEnter({
                                        target: td,
                                        eventKey: 'Enter',
                                    });
                                }
                                //bug 录入后enter键选择后值没有选上
                                /*if (executeEnterEvent({ containerDom, onEnter, currentTarget })) {
                                                            onHotKeyClose();
                                                        }*/
                            }
                        }
                    },
                    // save: () => {
                    //     this.setState({
                    //         showDisabledBg: false,
                    //     });
                    // },
                }}
                attach={document.body}
                focused={true}
            ></HotKeys>,
        ];
    }
}
